import React, { useEffect, useRef, useState, useCallback  } from "react";
import './ProjectTasks.css'
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ColumnResizer from "react-table-column-resizer";
import axios, { all } from "axios";
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux';
import { setAddTask, setFullDate, setInitialDataObject, setReset, setDate, setGetLogs, setLoader, setDispatchAllTask, setDataObject, setTaskDetailObj, setTaskDetailFlag, setIsCommentView } from '../../../../erpStore/actions';
import profile from "../../../../assets/images/profile.png";
import { toast } from 'react-toastify';
import { Calendar } from "primereact/calendar";
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import { debounce } from 'throttle-debounce';
import { debounce } from 'lodash';

import { Space, TimePicker } from "antd";



const dummyTasks = [
  { id: 1, name: 'Task 1' },
  { id: 2, name: 'Task 2' },
  { id: 3, name: 'Task 3' },
  { id: 4, name: 'Task 4' },
  { id: 5, name: 'Task 1' },
  { id: 6, name: 'Task 2' },
  { id: 7, name: 'Task 3' },
  { id: 89, name: 'Task 4' }
];

const useStyles = makeStyles({
  table: {
    minWidth: 100
  },
  columnResizer: {
    backgroundColor: "rgb(182, 179, 179)",
    width: 1,
    minWidth: 1,
    maxWidth: 1,
    padding: 0,
    border: "1px solid black"
  },
  columnResizer1: {
    width: 1,
    minWidth: 1,
    maxWidth: 1,
    padding: 0,
    border: "1px solid grey",
    gap: 0
  }
});

function ProjectTasks() {
  const dataObjectInit = useSelector((state) => state.data.dataObject)
  const routeS = useSelector((state) => state.data.route)
  const editeKey = useSelector((state) => state.data.editeKey)
  const dispatch = useDispatch();
  const statusListRef = useRef(null);
  const priorityListRef = useRef(null)
  const projectListRef = useRef(null)
  const dueDateRef = useRef(null)
  const tagListRef = useRef(null)
  const verifiedListRef = useRef(null)
  const gitRef = useRef(null)
  const gitMsgRef = useRef(null)
  const assigneeRef = useRef(null)
  const headerStatusListRef = useRef(null)
  const priorityStatusListRef = useRef(null)
  const headerDueDateRef = useRef(null)
  const headerVerifiedListRef = useRef(null)
  const headerDuplicateRef = useRef(null)
  const headerShiftRef = useRef(null)
  const TAListRef = useRef(null)
  const strtTimeRef = useRef(null)
  const endTimeRef = useRef(null)
  const apiUrl = useSelector((state) => state.data.apiUrl);
  const sortedObject = useSelector((state) => state.data.sortObject);
  const [allTask, setAllTask] = useState([])
  const classes = useStyles();
  const empView = useSelector((state) => state.data.empView)
  const self = useSelector((state) => state.data.selfData)
  const empInfo = useSelector((state) => state.data.empInfo)
  const mtiID = useSelector((state) => state.data.mtiID)
  const [completeAnalytics, setCompleteAnalytics] = useState(0)
  const [totalAnalytics, setTotalAnalyatics] = useState(0)
  const getFullDate = useSelector((state) => state.data.fullDate)
  const [taskSelectedCount, setTaskSeletedCount] = useState(0)
  const [gitLinkInputBox, setgitLinkInputBox] = useState(false)
  const [gitLinkValue, setGitLinkValue] = useState('')
  const [taskIdGit, setGitTaskId] = useState()
  const url = useSelector((state) => state.data.apiUrl)
  const [routeDateDue, setRouteDateDue] = useState("")
  const [routeDateDuplicate, setRouteDateDuplicate] = useState("")
  const [routeDateShift, setRouteDateShift] = useState("")
  const [routeDateShiftSingle, setRouteDateShiftSingle] = useState("")
  const [upDatedTranferList, setUpdatedTranferList] = useState([])

  const dStatuses = useSelector((state) => state.data.statusList)
  const [statuses, setStatuses] = useState(dStatuses)

  const dPriorities = useSelector((state) => state.data.priorityList)
  const [priorities, setPriorities] = useState(dPriorities)

  const dProjects = useSelector((state) => state.data.projectlistUpdate)
  const [projects, setProjects] = useState(dProjects)

  const dVerifieds = useSelector((state) => state.data.verifiedList)
  const [verifieses, setVerifies] = useState(dVerifieds)

  const dTags = useSelector((state) => state.data.tagList)
  const [tags, setTags] = useState(dTags)

  const dAssignees = useSelector((state) => state.data.assgineeList)
  const [assigness, setAssigness] = useState([])

  const selfInfo = empView ? empInfo : self
  const selfInfoEmp = useSelector((state) => state.data.taskEmp)
  const [statusOption, setStatusOption] = useState(false)
  const [prorityOption, setPriorityOption] = useState(false)
  const [verfiedOption, setverifiedOption] = useState(false)
  const [dueDateOption, setDueDateOption] = useState(false)
  const [tagOption, setTagOption] = useState(false)
  const [taskIdOption, setTaskIdForOption] = useState()
  const [projectOption, setProjectOption] = useState(false)
  const [assigneeOption, setAssigneeOption] = useState(false)
  const [taskOfListPut, setTaskOfListPut] = useState([])
  const [headerStatusList, setStatusHeaderList] = useState(false)
  const [headerPriorityList, setPriorityHeaderList] = useState(false)
  const [headerVerifiedList, setVerifiedHeaderList] = useState(false)
  const [headerDudateCalender, setHeaderDueDatCal] = useState(false)
  const [headerDuplicate, setHeaderDuplicateCal] = useState(false)
  const [headerShiftTask, setHeaderShiftTask] = useState(false)
  const [dueDateput, setDueDatePut] = useState(null)
  const [dateForDuplicate, setdateForDuplicate] = useState(null)
  const [selectAllCheckBox, setSelectAllCheckBox] = useState(false)
  const taskUpdate = useSelector((state) => state.data.newTask)
  const fullDate = useSelector((state) => state.data.fullDate);
  var [addRunTimeTag, setRunTimeTag] = useState([])
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const [deleteTaskFlag, setDeleteTaskFlag] = useState(false)
  const stringHeaders = window.localStorage.getItem('myHeaders');
  const storedHeaders = JSON.parse(stringHeaders);
  const [fullDateForDue, setFullDateForDue] = useState()
  const [newTaskFlag, setNewTaskFlag] = useState(false)
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  const day = String(today.getDate()).padStart(2, '0');
  const [isRotating, setRotating] = useState(false)
  const todayDateFor = `${month}/${day}/${year}`;
  const todayDate = `${year}-${month}-${day}`
  const todayDateForTA = `${year}-${month}-${day}`;
  const [serchKeyTrsn, setSearchKeyTran] = useState('')
  const [transferClicked, setTransferClicked] = useState(false)
  const project = useSelector((state) => state.data.projectToUpadte)
  const [taskToTestpopup, settaskToTestpopup] = useState(false)
  const gitTaskpopRef = useRef(null);
  const [gitTaskObj, setGitTaskObj] = useState(null)
  const [saveGitFlag, setSaveGitFlag] = useState(false)
  const [testerFlag, setTesterFlag] = useState(false)
  const [testerTaskId, setTesterTaskId] = useState(null)
  const [sentTestGitFlag, setSentTestFlag] = useState(false)
  const [taskSearchKey, setTaskSearchKey] = useState('')
  const [isLMclick, setIsLMClick] = useState(false)

  function isJsonParse(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  var date1 = new Date(fullDate);
  // Extract year, month, and day
  var year1 = date1.getFullYear();
  var month1 = ('0' + (date1.getMonth() + 1)).slice(-2); // Adding 1 to month because it starts from 0
  var day1 = ('0' + date1.getDate()).slice(-2);

  // Form the formatted date string
  var formattedDateString = year1 + '-' + month1 + '-' + day1;
  const [dateForTransfer, setDateForTransfer] = useState(formattedDateString)
  var TodayDteComp = new Date()

  const dateString = "Mon May 13 2024 14:29:49 GMT+0530 (India Standard Time)";
  const date3 = new Date(dateString);
  const formattedDateComp = date3.toISOString().split('T')[0];
  const date = new Date(fullDate);
  const formattedDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
  const [taskOnwerDiffReq, setTaskOwnerDifReq] = useState([])
  const [taskOwnerDiff, setOwnerDiff] = useState(false)
  const [gitMsgForNoPrj, setGitMsgForNotPrj] = useState(false)
  const [isVisible, setIsVisible] = useState(false);
  const dateInputRef = useRef(null);
  const loader = useSelector((state) => state.data.loader)
  const [transforTaskPopUp, setTransforTaskPopUp] = useState(false)
  const [TAList, setTAList] = useState(false)
  const [selectedTA, setSelectedTA] = useState(null)
  const [taskOpenId, setTaskIdOpenBtn] = useState(null)
  const [dueTipIdFlag, setdueTipIdFlag] = useState(null)
  const [endTimeFlag, setEndTimeFlag] = useState(false)
  var newTask = []
  var tempTask = ''
  const dispatchAllTask = useSelector((state) => state.data.dispatchAllTask)
  const [multiplePutTasks, setTaskListMultiplePut] = useState([])
  const [retqMulFlag, setRetqMulFlag] = useState(false)
  const [taskOpenBtn, setTaskOenbtn] = useState(false)
  const [tooltipSchedule, setMsgShdtTip] = useState(false)
  const [tooltipDue, setMsgDueTip] = useState(false)
  const [startTimeFlag, setStartTimeFlag] = useState(false)
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState()
  const [fullDateF, setFullDateF] = useState()
  const taskDetailFalg = useSelector((state) => state.data.taskDetailFalg)
  const [reqtMsgFlag, setReqtMsgFlag] = useState(false)
  const [reqtMsgFlagStatus, setreqtMsgFlagStatus] = useState(false)
  const [taskReqtIdOpt, setTaskReqtIdOpt] = useState(null)
  const [reqtMsgFlagProject, setReqtMsgFlagProject] = useState(false)
  const [tempTaskTile, setTempTaskTitle] = useState(null)
  const transferDateRef = useRef(null)
  const [transferDateFlag, setTransferDteFlag] = useState(false)
  const [cmtOption, setCmtOption] = useState(false)
  const [reqtOptRow, setReqtOptRow] = useState(false)
  const [rowRqtMsg, setRowRqtMsg] = useState(null)
  const [selectedStartTime, setSelectedStartTime] = useState(null);
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const [viewdListFlg, setViewdListFlg] = useState(false)
  const [taskIdViewOPt, setTaskIdViewOPt] = useState(null)
  const [deleteloaderFlag, setDeleteloaderFlag] = useState(false)
  const [pageNumber, setPageNumber] = useState(0)
  const [isLastPage, setIsLastPage] = useState(null)

  const handleStartTimeChange = (time, index, taskObj) => {
    if (taskObj.taskTimeTo && moment(time).isAfter(moment(taskObj.taskSchedule + " " + taskObj.taskTimeTo)._d)) {
      toast.warning("Please Select Start time before End time")
      return
    }
    setSelectedStartTime(time);
    const splitTime = time.toString().split(" ")
    UPDATE(9, index, taskObj, splitTime[4]);
  };
  const handleEndTimeChange = (time, index, taskObj) => {
    if (!moment(time).isAfter(moment(taskObj.taskSchedule + " " + taskObj.taskTimeFrom)._d)) {
      toast.warning("Please Select End time after start time")
      return
    }
    setSelectedEndTime(time);
    const splitTime = time.toString().split(" ")
    UPDATE(10, index, taskObj, splitTime[4]);
  };

  const route = window.sessionStorage.getItem('route')
  const [isAssendingAssigned, setIsAssendingAssigned] = useState(true);
  const handleSortByAssigned = () => {
    setSortBy('assigned')
    if (isAssendingAssigned) {
      setIsAssendingAssigned(false)
      // toast.info("Sorted task name by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => a.taskOwner.empFullName.localeCompare(b.taskOwner.empFullName));
      setAllTask(sortedTasks)
    } else {
      setIsAssendingAssigned(true)
      // toast.info("Sorted task name by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => b.taskOwner.empFullName.localeCompare(a.taskOwner.empFullName));
      setAllTask(sortedTasks)
    }

  }
  useEffect(() => {
    function handleOutsideClick(event) {
      if (statusListRef && statusListRef.current && !statusListRef.current.contains(event.target)) {
        setStatusOption(false)
      } else if (priorityListRef && priorityListRef.current && !priorityListRef.current.contains(event.target)) {
        setPriorityOption(false)
      } else if (projectListRef && projectListRef.current && !projectListRef.current.contains(event.target)) {
        setProjectOption(false)
      } else if (dueDateRef && dueDateRef.current && !dueDateRef.current.contains(event.target)) {
        setDueDateOption(false)
      } else if (tagListRef && tagListRef.current && !tagListRef.current.contains(event.target)) {
        setTagOption(false)
      } else if (verifiedListRef && verifiedListRef.current && !verifiedListRef.current.contains(event.target)) {
        setverifiedOption(false)
      } else if (gitRef && gitRef.current && !gitRef.current.contains(event.target)) {
        setgitLinkInputBox(false)
      } else if (gitMsgRef && gitMsgRef.current && !gitMsgRef.current.contains(event.target)) {
        setGitMsgForNotPrj(false)
      } else if (assigneeRef && assigneeRef.current && !assigneeRef.current.contains(event.target)) {
        setAssigneeOption(false)
      } else if (headerStatusListRef && headerStatusListRef.current && !headerStatusListRef.current.contains(event.target)) {
        setStatusHeaderList(false)
      } else if (priorityStatusListRef && priorityStatusListRef.current && !priorityStatusListRef.current.contains(event.target)) {
        setPriorityHeaderList(false)
      } else if (headerDueDateRef && headerDueDateRef.current && !headerDueDateRef.current.contains(event.target)) {
        setHeaderDueDatCal(false)
      } else if (headerVerifiedListRef && headerVerifiedListRef.current && !headerVerifiedListRef.current.contains(event.target)) {
        setVerifiedHeaderList(false)
      } else if (headerDuplicateRef && headerDuplicateRef.current && !headerDuplicateRef.current.contains(event.target)) {
        setHeaderDuplicateCal(false)
      } else if (headerShiftRef && headerShiftRef.current && !headerShiftRef.current.contains(event.target)) {
        setHeaderShiftTask(false)
      } else if (TAListRef && TAListRef.current && !TAListRef.current.contains(event.target)) {
        setTAList(false)
      } else if (strtTimeRef && strtTimeRef.current && !strtTimeRef.current.contains(event.target)) {
        setStartTimeFlag(false)
      } else if (endTimeRef && endTimeRef.current && !endTimeRef.current.contains(event.target)) {
        setEndTimeFlag(false)
      } else if (transferDateRef && transferDateRef.current && !transferDateRef.current.contains(event.target)) {
        setTransferDteFlag(false)
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [])



  useEffect(() => {
    setAllTask(allTask)
  }, [allTask])


  useEffect(() => {

    getAllTaskList()
    setSelectAllCheckBox(false)
    setTaskOfListPut([])
    setTaskSeletedCount(0)
    setDateForTransfer()
  }, [])

  useEffect(() => {
    setAllTask(dispatchAllTask)
    setTotalAnalyatics(dispatchAllTask.length)

  }, [dispatchAllTask,])


  const getAllTaskList = () => {

    if(pageNumber === 0 ){
      dispatch(setLoader(true))
    }
    const splitFullDate = getFullDate.split(" ")
    const mNumber = getMonthNumber(splitFullDate[2])
    const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
    setFullDate(fullDateF)
    setFullDateForDue(fullDateF)
    const stringHeaders = window.localStorage.getItem('myHeaders');
    const userId = window.localStorage.getItem('id')
    const storedHeaders = JSON.parse(stringHeaders);
    let isView = false
    axios.post(`${apiUrl}project/task/get/all?page=${pageNumber}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
      .then(response => {
        if (response) {
          dispatch(setReset(0))
          var completedTaskCount = response.data.data?.filter(taskObj => taskObj.taskDone === 1).length;
          setTotalAnalyatics(response.data.data.length)
          setCompleteAnalytics(completedTaskCount);
          setAllTask(response.data.data)
          setSelectAllCheckBox(false)
          dispatch(setDispatchAllTask(response.data.data))
          dispatch(setDataObject(response.data))
          setPriorityOption(false)
          setStatusOption(false)
          setTaskOfListPut([])
          setSelectAllCheckBox(false)
          setIsLastPage(response.data.isLastPage)
          setRotating(false)
          setTimeout(() => {
            dispatch(setLoader(false))
          }, 500);
          if (selfInfoEmp.empId !== self.empId) {
            response.data.forEach(task => {
              let view = false;

              if (task.taskView.length > 0) {
                task.taskView.forEach(emp => {
                  if (emp.empId === self.empId) {
                    view = true;
                  }
                });
              }

              if (!view) {
                taskArr.push(task.taskId);
              }
            });
            handleViewEmp(response.data)
          }
        }
      })

      .catch(err => {
        dispatch(setLoader(false))
        // toast.error(`error occured`, { toastId: 'success', autoClose: 2000 });
      })
  }

  const handleToday_Tasks = () => {
    const today = new Date();
    const previousDate = moment(today.toString());

    const formattedDate =
      previousDate.format('dddd') +
      ', ' +
      previousDate.date() +
      ' ' +
      previousDate.format('MMM') +
      ' ' +
      previousDate.year();
    dispatch(setFullDate(formattedDate));
  }

  const getMonthNumber = (monthName) => {
    const monthMoment = moment().month(monthName).startOf('month');
    return monthMoment.format('MM');
  };


  const handleAllCheckBoxSelected = () => {

    var allTaskCheckBox = null
    allTaskCheckBox = document.getElementById('allSelectChecBox').checked

    if (allTaskCheckBox) {
      var updateSelectedTaskId = []
      var updateSelectecAllTasks = []
      updateSelectedTaskId = selectAllCheckBox ? [] : allTask.map((task) => task.taskId);
      updateSelectecAllTasks = selectAllCheckBox ? [] : allTask.map((taskObj) => taskObj)
      setTaskListMultiplePut(updateSelectecAllTasks)
      setTaskOfListPut(updateSelectedTaskId)
      setTaskOfListPut(updateSelectedTaskId)
      setTaskSeletedCount(updateSelectedTaskId.length)
      setSelectAllCheckBox(!selectAllCheckBox)
    } else {
      setTaskOfListPut([])
      setTaskSeletedCount(0)
      setSelectAllCheckBox(false)
    }
  }

  const handleTaskCheckBox = (taskId, taskObj) => {
    var chekedTask = null
    chekedTask = document.getElementById(`checkbox-${taskId}`).checked

    if (chekedTask) {
      setTaskOfListPut((prevTaskList) => [...prevTaskList, taskId,])
      // setTaskListMultiplePut((prevTaskList) => [...prevTaskList, taskObj])

      if (taskObj?.taskOwner?.empId !== selfInfoEmp?.empId) {
        setTaskOwnerDifReq(prevTaskList => [...prevTaskList, taskObj]);
      }
      setTaskSeletedCount(taskSelectedCount + 1)
    } else {
      setTaskOfListPut((prevTaskList) => prevTaskList.filter((id) => id !== taskId))
      setTaskListMultiplePut((prevTaskList) => prevTaskList.filter((takObj) => taskObj.taskId !== taskId))
      setTaskSeletedCount(taskSelectedCount - 1)
    }
    if (taskOfListPut.length !== taskSelectedCount && document.getElementById('allSelectChecBox').checked) {
      const allTasksChecked = taskOfListPut.length !== allTask.length;
      document.getElementById('allSelectChecBox').checked = allTasksChecked;
    }
  }



  const handleGitKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (isValidGitUrl(gitLinkValue)) {
        const stringHeaders = window.localStorage.getItem('myHeaders');
        const storedHeaders = JSON.parse(stringHeaders);
        const index = allTask.findIndex((obj) => obj.taskId === gitTaskObj.taskId)
        gitTaskObj.taskGitLink = gitLinkValue
        allTask[index] = gitTaskObj
        setAllTask(allTask)
        dispatch(setDispatchAllTask(allTask))
        setSaveGitFlag(true)
        setSaveGitFlag(true)
        axios.put(`${apiUrl}task/update`, { "taskId": gitTaskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskGitLink": gitLinkValue, 'taskToTest' : false}, { headers: storedHeaders })
          .then(response => {
            if (response.request.status === 200) {
              toast.success("task gitLink  Updated successfully", { toastId: 'success', autoClose: 2000 });
              settaskToTestpopup(false)
              setSaveGitFlag(false)
            }
            setAllTask(allTask)
            setSaveGitFlag(false)
          })
          .catch(err => { 
            setTesterFlag(false)
            setSaveGitFlag(false)
            toast.error("Error oCCured", { toastId: 'success', autoClose: 2000 });
          })
      } else {
        toast.error("Enter valid git link", { toastId: 'success', autoClose: 2000 });
        setTesterFlag(false)
        setTesterTaskId(null)
        setSaveGitFlag(false)
      }
    }
  }

  const handleGitInput = (e) => {
    setGitTaskId(e)
    setgitLinkInputBox(!gitLinkInputBox)
  }

  const handleGitInputChange = (e) => {
    setGitLinkValue(e.target.value)
  }

  useEffect(() => {
    // Focus the input field when isVisible becomes true
    const dateInput = document.querySelector("input");
    if (isVisible && dateInput) {
      dateInput.showPicker();
    }
  }, [isVisible]); // Effect depends on isVisible
  const taskArr = []
  const handleViewEmp = (tempAllTask) => {
    if (taskArr.length > 0) {
      try {
        const splitFullDate = getFullDate.split(" ")
        const mNumber = getMonthNumber(splitFullDate[2])
        const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
        axios.post(`${apiUrl}task/update-view`, {
          empId: selfInfoEmp.empId,
          date: fullDateF,
          task: taskArr
        }, {
          headers: storedHeaders
        })
          .then((response) => {
            if (response.request.status === 200) {
              if (selfInfoEmp.empId !== self.empId) {
                tempAllTask.map((task, index) => {
                  if (taskArr.includes(task.taskId)) {

                    let currentTime = new Date();

                    // Extract hours, minutes, and seconds
                    let hours = currentTime.getHours();
                    let minutes = currentTime.getMinutes();
                    let seconds = currentTime.getSeconds();

                    // Pad single digit values with leading zeros
                    if (hours < 10) {
                      hours = '0' + hours;
                    }
                    if (minutes < 10) {
                      minutes = '0' + minutes;
                    }
                    if (seconds < 10) {
                      seconds = '0' + seconds;
                    }

                    // Format the time as "HH:mm:ss"
                    let formattedTime = hours + ':' + minutes + ':' + seconds;

                    // Store the formatted time in a local variable
                    let localTime = formattedTime;


                    tempAllTask[index].taskView.push({
                      "empId": self.empId,
                      "empFullName": self.empFullName,
                      "empImg": self.empImg,
                      "viewedTimeStamp": formattedTime
                    });
                    setAllTask(tempAllTask)
                    dispatch(setDispatchAllTask(tempAllTask))
                  }
                });
              }
            }
          })
          .catch((err) => {
          })
      } catch {

      }
    }
  }



  const UPDATE = (e, index, taskObj, toUpdateObj, tagFlag) => {

    switch (e) {
      case 1:
        if (taskObj.statusEntity.statusId === toUpdateObj.statusId) {
          setStatusOption(false)
          toast.error(`task status already updated`, { toastId: 'success', autoClose: 2000 });
          setClicked(false)
        } else {
          axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskStatus": toUpdateObj.statusId }, { headers: storedHeaders })
            .then(response => {
              if (response.request.status === 200) {
                setClicked(false)
                if (toUpdateObj.statusId === 6) {
                  taskObj.taskDone = 1
                } else if (taskObj.statusEntity.statusId === 6 && toUpdateObj.statusId !== 6) {
                  taskObj.taskDone = 0
                }
                // if(taskObj.statusEntity.statusId === 5){

                // } else{
                //   taskObj.statusEntity = taskObj.statusEntity
                // }

                taskObj.statusEntity = toUpdateObj
                taskObj.request = response.data
                allTask[index] = taskObj
                setAllTask(allTask)
                dispatch(setDispatchAllTask(allTask))
                setStatusOption(false)
                if (response.data.statusEntity === true) {
                  toast.success("Request for update status sent successfully", { toastId: 'success', autoClose: 2000 });
                } else {
                  toast.success("task status updated successfully", { toastId: 'success', autoClose: 2000 });
                }
              }
            })
            .catch(err => {
              toast.error(`${err.response.status} error occured`, { toastId: 'success', autoClose: 2000 });
              setClicked(false)
            })
        }
        break;

      case 2:

        if (taskObj.priorityEntity.priorityId === toUpdateObj.priorityId) {
          toast.error(`task priority already updated`, { toastId: 'success', autoClose: 2000 });
          setPriorityOption(false)
          setClicked(false)
          return
        }

        axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskPriority": toUpdateObj.priorityId }, { headers: storedHeaders })
          .then(response => {
            if (response.request.status === 200) {
              setClicked(false)
              taskObj.request = response.data

              // if(response.data.priorityEntity === true){
              //   taskObj.priorityEntity =taskObj.priorityEntity 
              // }else{
              //   taskObj.priorityEntity = toUpdateObj 
              // }

              taskObj.priorityEntity = toUpdateObj
              allTask[index] = taskObj
              setPriorityOption(false)
              if (response.data.priorityEntity === true) {
                toast.success("request for update priority sent successfully", { toastId: 'success', autoClose: 2000 });
              } else {
                toast.success("task priority updated successfully", { toastId: 'success', autoClose: 2000 });
              }
            }
          })
          .catch(err => {
            toast.error(`${err.response.status} error occured`, { toastId: 'success', autoClose: 2000 });
            setClicked(false)
          })
        break;

      case 3:
        if (taskObj.projectEntity?.projectId === toUpdateObj?.projectId) {
          toast.error(`task Project already updated`, { toastId: 'success', autoClose: 2000 });
          setProjectOption(false)
          setClicked(false)
          return
        }
        axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskProject": toUpdateObj.projectId }, { headers: storedHeaders })
          .then(response => {
            setClicked(false)
            if (response.request.status === 200) {
              taskObj.request = response.data
              taskObj.projectEntity = toUpdateObj
              allTask[index] = taskObj
              setProjectOption(false)
              if (response.data.projectEntity === true) {
                toast.success("request for update project sent successfully", { toastId: 'success', autoClose: 2000 });
              } else {
                toast.success("task project updated successfully", { toastId: 'success', autoClose: 2000 });
              }
            }
            setProjectOption(false)
          })
          .catch((err) => {
            setClicked(false)
          })
        break;

      case 4:
        if (taskObj.taskDueDate === toUpdateObj) {
          toast.error(`task dueDate already updated`, { toastId: 'success', autoClose: 2000 });
          setDueDateOption(false)
          setClicked(false)
          return
        }
        axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskDueDate": toUpdateObj }, { headers: storedHeaders })
          .then(response => {
            if (response.request.status === 200) {
              setClicked(false)
              taskObj.request = response.data
              taskObj.taskDueDate = toUpdateObj
              allTask[index] = taskObj
              setDueDateOption(false)
              if (response.data.taskDueDate === true) {
                toast.success("request for update DueDate sent successfully", { toastId: 'success', autoClose: 2000 });
              } else {
                toast.success("task dueDate updated successfully", { toastId: 'success', autoClose: 2000 });
              }
            }
          })
          .catch(err => {
            toast.error(`${err.response.status} error occured`, { toastId: 'success', autoClose: 2000 });
            setClicked(false)
          })
        break;
      case 5:
        switch (tagFlag) {
          case 0:
            handlePutTags(index, taskObj, toUpdateObj)
            break;

          default:
            removeFromRuntime(index, taskObj, toUpdateObj)
            break;
        }
        break;

      case 6:
        if (taskObj.taskOwner.empId === toUpdateObj.empId) {
          toast.error(`taskOwner already updated`, { toastId: 'success', autoClose: 2000 });
          setAssigneeOption(false)
          return
        }
        axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskOwner": toUpdateObj.empId }, { headers: storedHeaders })
          .then(response => {
            if (response.request.status === 200) {
              taskObj.taskOwner = { 'empId': toUpdateObj.empId, 'empFullName': toUpdateObj.empFullName, 'empImg': toUpdateObj.empImg }
              taskObj.taskOwnerImage = toUpdateObj.empImg
              allTask[index] = taskObj
              setAssigneeOption(false)
              toast.success("task Owner Updated successfully", { toastId: 'success', autoClose: 2000 });
            }
          })
          .catch(err => {
            toast.success("task Owner Updated successfully", { toastId: 'success', autoClose: 2000 });
          })
        break;

      case 7:

        if (taskObj.taskGitLink === null) {
          toast.error(`Please add gitlink first`, { toastId: 'success', autoClose: 2000 });
          return
        }

        if (taskObj.task_verified.verificationStatusId === toUpdateObj.verificationStatusId) {
          toast.error(`task Verified status already updated`, { toastId: 'success', autoClose: 2000 });
          setverifiedOption(false)
          return
        }

        axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskVerificationStatus": toUpdateObj.verificationStatusId }, { headers: storedHeaders })
          .then(response => {
            if (response.request.status === 200) {
              taskObj.task_verified = toUpdateObj
              allTask[index] = taskObj
              setverifiedOption(false)
              toast.success("task verification status Updated successfully", { toastId: 'success', autoClose: 2000 });
            }
          })

          .catch(err => {
          })
        break;

      case 8:
        if (isValidGitUrl(toUpdateObj)) {
          axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskGitLink": toUpdateObj }, { headers: storedHeaders })
            .then(response => {
              if (response.request.status === 200) {
                taskObj.taskGitLink = toUpdateObj
                allTask[index] = taskObj
                setGitLinkValue('')
                setgitLinkInputBox(!gitLinkInputBox)
                setGitTaskId(null)
                toast.success("task gitLink  Updated successfully", { toastId: 'success', autoClose: 2000 });
              }
              setAllTask(allTask)
            })
            .catch(err => { })


        } else {
          toast.error("Enter valid git link", { toastId: 'success', autoClose: 2000 });
        }

        break;

      case 9:
        if (toUpdateObj === taskObj.taskTimeTo) {
          toast.error("select previous time from end time", { toastId: 'success', autoClose: 2000 });
          setSelectedStartTime(null)
        } else if (toUpdateObj === taskObj.taskTimeFrom) {
          toast.error("start time is already selected", { toastId: 'success', autoClose: 2000 });
          setSelectedStartTime(null)
        } else {
          axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTimeFrom": `${toUpdateObj}` }, { headers: storedHeaders })
            .then(response => {
              if (response.request.status === 200) {
                taskObj.taskTimeFrom = toUpdateObj
                allTask[index] = taskObj
                toast.success("Start-time Updated successfully", { toastId: 'success', autoClose: 2000 });
                //   getAllTaskList()
              }
            })

            .catch(err => {
              setSelectedStartTime(null)
            })
        }
        break;

      case 10:
        if (toUpdateObj === taskObj.taskTimeFrom) {
          toast.error("select end-time after start time", { toastId: 'success', autoClose: 2000 });
          setSelectedEndTime(null)
        } else if (toUpdateObj === taskObj.taskTimeTo) {
          toast.error("start time is already selected", { toastId: 'success', autoClose: 2000 });
          setSelectedEndTime(null)
        } else {
          axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTimeTo": `${toUpdateObj}` }, { headers: storedHeaders })
            .then(response => {
              if (response.request.status === 200) {
                taskObj.taskTimeTo = toUpdateObj
                allTask[index] = taskObj
                toast.success("End time Updated successfully", { toastId: 'success', autoClose: 2000 });
                //   getAllTaskList()
              }
            })
            .catch(err => {
              setSelectedEndTime(null)
            })
        }
        break;
      default:
        break
    }
  }

  function isValidGitUrl(url) {
    // Regular expression for GitLab and GitHub URLs
    const gitUrlRegex = /^(https?:\/\/)((?:www\.)?(?:gitlab\.com|github\.com|drive\.google\.com|doc\.google\.com))\/.*/;

    // Check if the URL matches the regex
    return gitUrlRegex.test(url);
  }

  const ADD = () => {

    // const foundStatus = statuses.find(status => status.statusId === 1);
    // const foundPriority = priorities.find(priority => priority.priorityId === 1)
    // const foundVerified = verifieses.find(verified => verified.verificationStatusId === 3)

    const splitFullDate = getFullDate.split(" ")
    const mNumber = getMonthNumber(splitFullDate[2])
    const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + (splitFullDate[1].length > 1 ? splitFullDate[1] : '0' + splitFullDate[1])
    dispatch(setDate(fullDate))


    let currentTime = new Date();

    // Extract hours, minutes, and seconds
    let hours = currentTime.getHours();
    let minutes = currentTime.getMinutes();
    let seconds = currentTime.getSeconds();

    // Pad single digit values with leading zeros
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    // Format the time as "HH:mm:ss"
    let formattedTime = hours + ':' + minutes + ':' + seconds;

    // Store the formatted time in a local variable
    let localTime = formattedTime;


    newTask = {
      "taskId": null,
      "taskTitle": null,
      "priorityEntity": priorities[0],
      "projectEntity": null,
      "statusEntity": statuses[0],
      "tags": [selfInfoEmp.department],
      "employee": [selfInfoEmp.empId],
      "taskComment": "",
      "taskDone": 0,
      "taskDueDate": fullDateF,
      "taskOwner": { "empId": self.empId, "empFullName": self.empFullName, "empImg": self.empImg },
      "task_verified": verifieses[0],
      "taskOwnerImage": self.empImg,
      "taskGitLink": null,
      'taskSchedule': fullDateF,
      'taskDone': 0,
      'taskView': route === 'level' && self.empId !== selfInfoEmp.empId ? [{ "empFullName": self.empFullName, "empId": self.empId, "empImg": self.empImg, "viewedTimeStamp": `${fullDateF} ${localTime}` }] : [],
      'request': {
        "task_verified": false,
        "taskDueDate": false,
        "taskSchedule": false,
        "projectEntity": false,
        "statusEntity": false,
        "taskGitLink": false,
        "taskTitle": false,
        "priorityEntity": false,
        "taskDelete": false,
        "taskTransfer": false
      }
    }

    setNewTaskFlag(true)
    setAllTask(prevAllTask => [...prevAllTask, newTask]);
  }

  const UPDATE_MULTIPLE = (e, putUpdateObj) => {
    const stringHeaders = window.localStorage.getItem('myHeaders');
    const storedHeaders = JSON.parse(stringHeaders);

    let tempTaskOfPut = []
    let tempTaskOfPut1 = []
    switch (e) {

      case 0:
            tempTaskOfPut = []
            taskOfListPut.forEach((taskId, index) => {
              allTask.forEach((task, index) => {
                if (taskId === task.taskId && putUpdateObj.statusId !== task.statusEntity.statusId) {
                  if(putUpdateObj?.statusId === 5){
                    task.request.statusEntity = true 
                  }else{
                    task.request.statusEntity = false 
                  }
                    task.statusEntity = putUpdateObj
                    allTask[index] = task
                    setAllTask(allTask)
                    dispatch(setDispatchAllTask(allTask))
                  if (task.taskView.length === 0) {
                  } else {
                    tempTaskOfPut.push(taskId);
                  }
                }
              });
            });

            if (tempTaskOfPut.length === 0) {
              toast.success('task status already updated', { autoClose: 2000 })
              return
            }

            axios.put(`${apiUrl}task/multiple/update`, { "task": tempTaskOfPut, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskStatus": putUpdateObj.statusId }, { headers: storedHeaders })
              .then(responseData => {
                if (responseData.request.status === 200) {             
                  setStatusHeaderList(!headerStatusList)
                  Object.keys(responseData.data).forEach(taskId => {
                    const index = allTask.findIndex( task => task?.taskId === parseInt(taskId))
                    allTask[index].request = responseData.data[taskId]
                    setAllTask(allTask)
                    dispatch(setDispatchAllTask(allTask))
                  })
     
                  toast.success('Status Updated Successfully', { autoClose: 2000 })
                }
              })
              .catch(err => { {} })
  
        break;

      case 1:
            tempTaskOfPut = []
            taskOfListPut.forEach((taskId, index) => {
              allTask.forEach((task) => {
                if (taskId === task.taskId && putUpdateObj.priorityId !== task.priorityEntity.priorityId) {
                    tempTaskOfPut.push(taskId);
                    task.priorityEntity = putUpdateObj
                    allTask[index] = task
                }
                setAllTask(allTask)
                dispatch(setDispatchAllTask(allTask))
              });
            });

            if (tempTaskOfPut.length === 0) {
              toast.success('task priority already updated', { autoClose: 2000 })
              return
            }

            axios.put(`${apiUrl}task/multiple/update`, { "task": tempTaskOfPut, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskPriority": putUpdateObj.priorityId }, { headers: storedHeaders })
              .then(responseData => {
                if (responseData.request.status === 200) {
                  setPriorityHeaderList(!headerPriorityList)
                  Object.keys(responseData.data).forEach(taskId => {
                    const index = allTask.findIndex( task => task?.taskId === parseInt(taskId))
                    allTask[index].request = responseData.data[taskId]
                    setAllTask(allTask)
                    dispatch(setDispatchAllTask(allTask))
                  })
                  toast.success('priority Updated Successfully', { autoClose: 2000 })
                }
              })
              .catch(err => { {
                  
              } })
        break;

      case 2:

          if (selfInfoEmp?.empJoiningDate > putUpdateObj) {
            toast.error('You can not select the duedate as previous joining date')
            return
          }

          tempTaskOfPut = [];
          taskOfListPut.forEach((taskId, index) => {
            allTask.forEach((task) => {
              if (taskId === task.taskId && putUpdateObj.toString() !== task.taskDueDate.toString()) {
                tempTaskOfPut.push(taskId);
                task.taskDueDate = putUpdateObj
                allTask[index] = task
              }
              setAllTask(allTask)
              dispatch(setDispatchAllTask(allTask))
            });
          });

          if (tempTaskOfPut.length === 0) {
            toast.success('tasks dueDate are already updated', { autoClose: 2000 })
            return
          }

          axios.put(`${apiUrl}task/multiple/update`, { "task": tempTaskOfPut, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskDueDate": putUpdateObj }, { headers: storedHeaders })
            .then(responseData => {
              if (responseData.request.status === 200) {
                  Object.keys(responseData.data).forEach(taskId => {
                  const index = allTask.findIndex( task => task?.taskId === parseInt(taskId))
                  allTask[index].request = responseData.data[taskId]
                  setAllTask(allTask)
                  dispatch(setDispatchAllTask(allTask))
                })
                toast.success('due date update successfully', { autoClose: 2000})
                setHeaderDueDatCal(false)
              }
            })
            .catch(err => { {} })
        break;

      case 3:
        const splitFullDate = getFullDate.split(" ")
        const mNumber = getMonthNumber(splitFullDate[2])
        const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
        setFullDate(fullDateF)

        if (putUpdateObj < selfInfoEmp.empJoiningDate) {
          toast.error('You cannot select a date before the joining date.', { autoClose: 2000 });
          return;
        }

        axios.post(`${apiUrl}task/duplicate`, { "task": taskOfListPut, "empId": mtiID === true ? null : selfInfoEmp.empId, "date": putUpdateObj }, { headers: storedHeaders })
          .then(response => {
            if (response.request.status === 200) {
              taskOfListPut.forEach((taskId, indexOuter) => {
                dispatchAllTask.map((taskObj, index) => {
                  if (taskObj.taskId === taskId) {
                    let tempObj = { ...taskObj };
                    tempObj.taskOwner = { "empFullName": self.empFullName, "empId": self.empId, 'empImg': self.empImg }
                    tempObj.taskOwnerImage = self.empImg
                    tempObj.taskId = response.data[indexOuter]
                    dispatchAllTask.push(tempObj)
                    setAllTask(allTask)
                    dispatch(setDispatchAllTask(dispatchAllTask))
                    setHeaderDuplicateCal(false)
                    toast.success(`Tasks duplicated successfully`, { toastId: 'success', autoClose: 2000 });
                  }
                })
              })
            }
          })
          .catch(err => { {} })
        break;

      case 4:
        deleteTasks()
        break;

      case 5:
        if (route === 'level') {
          if (self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") {
            axios.put(`${apiUrl}task/multiple-shift`, { "task": taskOfListPut, "taskScheduleDate": putUpdateObj }, { headers: storedHeaders })
              .then(responseData => {
                var tempAllTask = [...allTask]
                if (responseData.request.status === 200) {
                  dispatch(setLoader(true))
                  const splitFullDate = getFullDate.split(" ")
                  const mNumber = getMonthNumber(splitFullDate[2])
                  const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
                  setFullDate(fullDateF)
                  setFullDateForDue(fullDateF)
                  const stringHeaders = window.localStorage.getItem('myHeaders');
                  const storedHeaders = JSON.parse(stringHeaders);
                  const getAllTaskUrl = `${apiUrl}project/task/get/all`
                  axios.post(`${apiUrl}project/task/get/all?page=${0}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
                    .then(response => {
                        if (response) {
                          dispatch(setInitialDataObject(response))
                          dispatch(setReset(0))
                          var completedTaskCount = response.data?.filter(taskObj => taskObj.taskDone === 1).length;
                          setTotalAnalyatics(response.data.length)
                          setCompleteAnalytics(completedTaskCount);
                          setAllTask(response.data.data)
                          dispatch(setDispatchAllTask(response.data.data))
                          setIsLastPage(response.data.isLastPage)
                          dispatch(setDataObject(response))
                          setTimeout(() => {
                            dispatch(setLoader(false))
                          }, 500);
                        }
                      })

                      .catch(err => {})
                  setHeaderDueDatCal(false)
                  setSelectAllCheckBox(false)
                  setTaskOfListPut([])
                  setTaskSeletedCount(0)
                  Object.keys(responseData.data).forEach(task => {
                    var taskObj = allTask.filter(taskObj => parseInt(taskObj.taskId) === parseInt(task))
                    switch (parseInt(responseData.data[task].statusCodeValue)) {
                      case 200:
                        toast.success(`shifted successfully`);
                        break;
                      case 103:
                        toast.success(`shift request send successfully`);
                        break;
                      case 403:
                        toast.error(`${taskObj[0].taskTitle} : can't shifted`);
                        break;
                      default:
                        // Handle any other status codes if needed
                        break;
                    }
                  });
                }
              })
              .catch(err => {
                setHeaderShiftTask(false)
                toast.error(`tasks not shifted`, { toastId: 'success', autoClose: 2000 });
              })
          } else {
            if (self.empId.toString() === empInfo.empId.toString()) {
              axios.put(`${apiUrl}task/multiple-shift`, { "task": taskOfListPut, "taskScheduleDate": putUpdateObj }, { headers: storedHeaders })
                .then(responseData => {
                  var tempAllTask = [...allTask]
                  if (responseData.request.status === 200) {
                    dispatch(setLoader(true))
                    const splitFullDate = getFullDate.split(" ")
                    const mNumber = getMonthNumber(splitFullDate[2])
                    const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
                    setFullDate(fullDateF)
                    setFullDateForDue(fullDateF)
                    const stringHeaders = window.localStorage.getItem('myHeaders');
                    const storedHeaders = JSON.parse(stringHeaders);
                    const getAllTaskUrl = `${apiUrl}project/task/get/all`
                    axios.post(`${apiUrl}project/task/get/all?page=${0}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
                    .then(response => {
                        if (response) {
                          dispatch(setInitialDataObject(response))
                          dispatch(setReset(0))
                          var completedTaskCount = response.data?.filter(taskObj => taskObj.taskDone === 1).length;
                          setTotalAnalyatics(response.data.length)
                          setCompleteAnalytics(completedTaskCount);
                          setAllTask(response.data.data)
                          dispatch(setDispatchAllTask(response.data.data))
                          setIsLastPage(response.data.isLastPage)
                          dispatch(setDataObject(response))
                          setTimeout(() => {
                            dispatch(setLoader(false))
                          }, 500);
                        }
                      })

                      .catch(err => {})
                    setHeaderDueDatCal(false)
                    setSelectAllCheckBox(false)
                    setTaskOfListPut([])
                    setTaskSeletedCount(0)
                    Object.keys(responseData.data).forEach(task => {
                      var taskObj = allTask.filter(taskObj => parseInt(taskObj.taskId) === parseInt(task))
                      switch (parseInt(responseData.data[task].statusCodeValue)) {
                        case 200:
                          toast.success(`shifted successfully`);
                          break;
                        case 103:
                          toast.success(`shift request send successfully`);
                          break;
                        case 403:
                          toast.error(`${taskObj[0].taskTitle} : can't shifted`);
                          break;
                        default:
                          // Handle any other status codes if needed
                          break;
                      }
                    });
                  }
                })
                .catch(err => {
                  setHeaderShiftTask(false)
                  toast.error(`tasks not shifted`, { toastId: 'success', autoClose: 2000 });
                })
            } else {
              tempTaskOfPut1 = []
              taskOfListPut.forEach((taskId, index) => {
                allTask.forEach((task) => {
                  if (taskId === task.taskId && self.empId === task.taskOwner.empId) {
                    tempTaskOfPut1.push(task.taskId);
                  }
                });
              });

              if (tempTaskOfPut1.length === 0) {
                toast.error('there is no task assigned by you for shift', { autoClose: 2000 })
                return
              }
              axios.put(`${apiUrl}task/multiple-shift`, { "task": taskOfListPut, "taskScheduleDate": putUpdateObj }, { headers: storedHeaders })
                .then(responseData => {
                  var tempAllTask = [...allTask]
                  if (responseData.request.status === 200) {
                    dispatch(setLoader(true))
                    const splitFullDate = getFullDate.split(" ")
                    const mNumber = getMonthNumber(splitFullDate[2])
                    const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
                    setFullDate(fullDateF)
                    setFullDateForDue(fullDateF)
                    const stringHeaders = window.localStorage.getItem('myHeaders');
                    const storedHeaders = JSON.parse(stringHeaders);
                    const getAllTaskUrl = `${apiUrl}project/task/get/all`
                    axios.post(`${apiUrl}project/task/get/all?page=${0}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
                    .then(response => {
                        if (response) {
                          dispatch(setInitialDataObject(response))
                          dispatch(setReset(0))
                          var completedTaskCount = response.data?.filter(taskObj => taskObj.taskDone === 1).length;
                          setTotalAnalyatics(response.data.length)
                          setCompleteAnalytics(completedTaskCount);
                          setAllTask(response.data.data)
                          dispatch(setDispatchAllTask(response.data.data))
                          setIsLastPage(response.data.isLastPage)
                          dispatch(setDataObject(response))
                          setTimeout(() => {
                            dispatch(setLoader(false))
                          }, 500);
                        }
                      })

                      .catch(err => {})
                    setHeaderDueDatCal(false)
                    setSelectAllCheckBox(false)
                    setTaskOfListPut([])
                    setTaskSeletedCount(0)
                    Object.keys(responseData.data).forEach(task => {
                      var taskObj = allTask.filter(taskObj => parseInt(taskObj.taskId) === parseInt(task))
                      switch (parseInt(responseData.data[task].statusCodeValue)) {
                        case 200:
                          toast.success(`shifted successfully`);
                          break;
                        case 103:
                          toast.success(`shift request send successfully`);
                          break;
                        case 403:
                          toast.error(`${taskObj[0].taskTitle} : can't shifted`);
                          break;
                        default:
                          // Handle any other status codes if needed
                          break;
                      }
                    });
                  }
                })
                .catch(err => {
                  setHeaderShiftTask(false)
                  toast.error(`tasks not shifted`, { toastId: 'success', autoClose: 2000 });
                })
            }
          }
        } else {
          axios.put(`${apiUrl}task/multiple-shift`, { "task": taskOfListPut, "taskScheduleDate": putUpdateObj }, { headers: storedHeaders })
            .then(responseData => {
              var tempAllTask = [...allTask]
              if (responseData.request.status === 200) {
                dispatch(setLoader(true))
                const splitFullDate = getFullDate.split(" ")
                const mNumber = getMonthNumber(splitFullDate[2])
                const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
                setFullDate(fullDateF)
                setFullDateForDue(fullDateF)
                const stringHeaders = window.localStorage.getItem('myHeaders');
                const storedHeaders = JSON.parse(stringHeaders);
                const getAllTaskUrl = `${apiUrl}project/task/get/all`
                axios.post(`${apiUrl}project/task/get/all?page=${0}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
                    .then(response => {
                        if (response) {
                          dispatch(setInitialDataObject(response))
                          dispatch(setReset(0))
                          var completedTaskCount = response.data?.filter(taskObj => taskObj.taskDone === 1).length;
                          setTotalAnalyatics(response.data.length)
                          setCompleteAnalytics(completedTaskCount);
                          setAllTask(response.data.data)
                          dispatch(setDispatchAllTask(response.data.data))
                          setIsLastPage(response.data.isLastPage)
                          dispatch(setDataObject(response))
                          setTimeout(() => {
                            dispatch(setLoader(false))
                          }, 500);
                        }
                      })

                      .catch(err => {})
                setHeaderDueDatCal(false)
                setSelectAllCheckBox(false)
                setTaskOfListPut([])
                setTaskSeletedCount(0)
                Object.keys(responseData.data).forEach(task => {
                  var taskObj = allTask.filter(taskObj => parseInt(taskObj.taskId) === parseInt(task))
                  switch (parseInt(responseData.data[task].statusCodeValue)) {
                    case 200:
                      toast.success(`shifted successfully`);
                      break;
                    case 103:
                      toast.success(`shift request send successfully`);
                      break;
                    case 403:
                      toast.error(`${taskObj[0].taskTitle} : can't shifted`);
                      break;
                    default:
                      // Handle any other status codes if needed
                      break;
                  }
                });
              }
            })
            .catch(err => {
              setHeaderShiftTask(false)
              toast.error(`tasks not shifted`, { toastId: 'success', autoClose: 2000 });
            })
        }
        break;

      case 6:
        if (selectedTA === null) {
          setTransferClicked(false)
          toast.error(`Please select task assignee first`, { toastId: 'success', autoClose: 2000 });
          return
        }
        axios.post(`${url}task/delegate-task`, { "empId": selectedTA?.empId, 'task': taskOfListPut, 'date': dateForTransfer, 'loggedInUsr': self?.userId, "operationDate": null }, { headers: storedHeaders })
          .then(responseData => {
            if (responseData.request.status === 200) {
              Object.keys(responseData.data).forEach(taskId => {
                const taskIndex = dispatchAllTask.findIndex(task => parseInt(task.taskId) === parseInt(taskId))
                if(selfInfo.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ){
                  allTask[taskIndex].taskEmployee = selectedTA
                  setAllTask(allTask)
                  dispatch(setDispatchAllTask(allTask))
                }else{
                  switch (parseInt(responseData.data[`${taskId}`].statusCodeValue)) {
                  case 200:
                    dispatchAllTask.splice(taskIndex, 1)
                    dispatch(setDispatchAllTask(allTask))
                    toast.success(`task transfer successfully`, { toastId: 'success', autoClose: 2000 });
                    break;
                  case 103:
                    dispatchAllTask[taskIndex].request.taskTransfer = true
                    setAllTask(dispatchAllTask)
                    dispatch(setDispatchAllTask(dispatchAllTask))
                    toast.success(`transfer request send successfully`, { toastId: 'success', autoClose: 2000 });
                    break;
                  case 403:
                    setAllTask(dispatchAllTask)
                    setDispatchAllTask(dispatchAllTask)
                    toast.error(` can't transfer`, { toastId: 'success', autoClose: 2000 });
                    break;
                  default:
                    break;
                }
                }
              });
              setTransforTaskPopUp(false)
              setSelectAllCheckBox(false)
              setTaskSeletedCount(0)
              setTaskOfListPut([])
              setSelectedTA(null)
              setClicked(false)
              setTransferClicked(false)
            }
          })
          .catch(err => {
            {}
            toast.error(`tasks  transfer fail`, { toastId: 'success', autoClose: 2000 });
            setTransferDteFlag(false)
            setTransferClicked(false)
            setClicked(false)
          })

        break;

      default:

    }
  }

  const deleteTasks = () => {
    setDeleteloaderFlag(true)
    var tempTaskOfPut1 = []
        axios.put(`${apiUrl}task/delete`, { "task": taskOfListPut }, { headers: storedHeaders })
          .then(responseData => {
            var tempAllTask = [...allTask]
            if (responseData.request.status === 200) {
              const splitFullDate = getFullDate.split(" ")
              const mNumber = getMonthNumber(splitFullDate[2])
              const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
              setFullDate(fullDateF)
              setFullDateForDue(fullDateF)
              const stringHeaders = window.localStorage.getItem('myHeaders');
              const storedHeaders = JSON.parse(stringHeaders);
              const getAllTaskUrl = `${apiUrl}project/task/get/all`
              axios.post(`${apiUrl}project/task/get/all?page=${0}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
              .then(response => {
                  if (response.request.status === 200) {
                    dispatch(setInitialDataObject(response.data.data))
                    dispatch(setReset(0))
                    var completedTaskCount = response.data.data?.filter(taskObj => taskObj.taskDone === 1).length;
                    setTotalAnalyatics(response.data.data.length)
                    setCompleteAnalytics(completedTaskCount);
                    setAllTask(response.data.data)
                    dispatch(setDispatchAllTask(response.data.data))
                    setIsLastPage(response.data.isLastPage)
                    dispatch(setDataObject(response.data.data))
                    setDeleteTaskFlag(false)
                    setDeleteloaderFlag(false)
                    setTimeout(() => {
                      dispatch(setLoader(false))
                    }, 500);
                  }
                })

              .catch(err => {})
              setDeleteTaskFlag(false)
              setTaskOfListPut([])
              setSelectAllCheckBox(false)
              setTaskSeletedCount(0)
              setDeleteloaderFlag(false)
              Object.keys(responseData.data).forEach(task => {
                var taskObj = allTask.filter(taskObj => parseInt(taskObj.taskId) === parseInt(task))
                switch (parseInt(responseData.data[task].statusCodeValue)) {
                  case 200:
                    toast.success(`task deleted successfully`, { toastId: 'success', autoClose: 2000 });
                    break;
                  case 103:
                    toast.success(`delete request send successfully`, { toastId: 'success', autoClose: 2000 });
                    break;
                  case 403:
                    toast.error(` ${taskObj[0].taskTitle} : can't delete`, { toastId: 'success', autoClose: 2000 });
                    break;
                  default:
                    // Handle any other status codes if needed
                    break;
                }
              });
            }
          })
          .catch(err => {
            toast.error(`tasks deleted fail`, { toastId: 'success', autoClose: 2000 });
            setDeleteTaskFlag(false)
            setDeleteloaderFlag(false)
          })
      } 


  const removeFromRuntime = (index, taskObj, removeId) => {
    const filteredTags = addRunTimeTag.filter(tag => tag.departmentId !== removeId);
    setRunTimeTag(filteredTags);
    let newArr = filteredTags;
    const tagIdArray = newArr.map(tag => tag.departmentId);
    const stringHeaders = window.localStorage.getItem('myHeaders');
    const storedHeaders = JSON.parse(stringHeaders);

    axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTags": tagIdArray }, { headers: storedHeaders })
      .then(response => {
        if (response.request.status === 200) {
          taskObj.tags = newArr;
          allTask[index] = taskObj
          toast.success("task Departments Updated successfully", { toastId: 'success', autoClose: 2000 });
        }
      })
      .catch(error => {});
  }

  const handlePutTags = (index, taskObj, tagObj) => {
    const isTagAlreadyAdded = addRunTimeTag.some(tag => tag.departmentName === tagObj.departmentName);
    let newArr = addRunTimeTag;
    if (!isTagAlreadyAdded) {
      setRunTimeTag([...addRunTimeTag, tagObj]);
      newArr = [...addRunTimeTag, tagObj];

    }

    const tagIdArray = newArr.map(tag => tag.departmentId);
    const stringHeaders = window.localStorage.getItem('myHeaders');
    const storedHeaders = JSON.parse(stringHeaders);
    axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTags": tagIdArray }, { headers: storedHeaders })
      .then(response => {
        if (response.request.status === 200) {
          taskObj.tags = newArr;
          allTask[index] = taskObj
          toast.success("task Departments Updated successfully", { toastId: 'success', autoClose: 2000 });
        }
      })
      .catch(error => {}); // Changed response to error
  }
  const isDateLessThanCurrent = (date) => {
    const givenDate = moment(date); // Convert string to Date object
    const currentDate = moment().subtract(1, 'day'); // Get current date
    const validDate = moment(currentDate._d)
    // Compare the dates
    return givenDate > validDate;
  };

  const isDateLessThanCurrentforDue = (date) => {
    const givenDate = moment(date); // Convert string to Date object
    const currentDate = moment().subtract(0, 'day'); // Get current date
    const validDate = moment(currentDate._d)

    const today = new Date(validDate._d);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return givenDate._i < formattedDate;
  };

  function generateBeep() {
    const oscillator = audioContext.createOscillator();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(400, audioContext.currentTime);
    oscillator.connect(audioContext.destination);
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.1);
  }
  const handleTaskChange = (e, index, taskObj) => {
    if (e.target.value.length <= 100) {
      const updatedTasks = [...allTask];
      updatedTasks[index].taskTitle = e.target.value;
      setAllTask(updatedTasks);
      tempTask = e.target.value;
    }
  };

  const handleCommentsChange = (e, index) => {
    const updatedTasks = [...allTask];
    updatedTasks[index].taskComment = e.target.value;
    setAllTask(updatedTasks);

  };

  const handleCommentsEdit = (e, index, taskObj) => {

    axios.put(`${apiUrl}task/update`, { 'taskId': taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, 'taskComment': e.target.value }, { headers: storedHeaders })
      .then((response) => {
        if (response.request.status === 200) {
          allTask[index] = taskObj
          toast.success(`Comment updated successfully`, { toastId: 'success', autoClose: 2000 });
        }
      })
      .catch(error => {
        toast.error("comment not updated", { toastId: 'success', autoClose: 2000 });
      })
  };
  const [addTaskCall, setAddtaskCall] = useState(false)
  const handleBlur = (e, taskObj, index) => {
    if (e.key === 'Enter' && !addTaskCall) {
      setAddtaskCall(true)
      if (taskObj.taskId === null) {
        if ((taskObj?.taskTitle === '' || taskObj?.taskTitle === null) && taskObj?.taskId === null) {
          setAddtaskCall(false)
          return
        } else if (newTaskFlag === true && taskObj.taskTitle !== null && taskObj.taskId === null) {
          const splitFullDate = getFullDate.split(" ");
          const mNumber = getMonthNumber(splitFullDate[2]);
          const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + (splitFullDate[1].length > 1 ? splitFullDate[1] : '0' + splitFullDate[1])
          const temp = {
            "taskTitle": [e.target.value],
            "employee": [selfInfoEmp.empId],
            "taskScheduleDate": fullDateF,
            "taskTags": [selfInfoEmp.department?.departmentId],
            "taskStatus": statuses[0].statusId,
            "taskPriority": priorities[0].priorityId
          }

          axios.post(`${apiUrl}task/add`, temp, { headers: storedHeaders })
            .then((response) => {
              if (response.request.status === 201) {
                taskObj.taskId = parseInt(response.data.taskId)
                taskObj.taskTitle = e.target.value
                dispatch(setDispatchAllTask(allTask))
                dataObjectInit.data = allTask
                setDataObject(dataObjectInit)
                e.target.blur();
                generateBeep();
                setNewTaskFlag(true)
                newTask = []
                toast.success("task added successfully", { toastId: 'success', autoClose: 2000 });

              }
              setAddtaskCall(false)
            })
            .catch((error) => {
              setAddtaskCall(false)
            });
        }
      } else {

        if (e.target.value === '') {
          toast.error('task already updated')
          setAddtaskCall(false)
          return
        }

        axios.put(`${apiUrl}task/update`, { taskId: taskObj.taskId, empId: selfInfoEmp.empId, taskTitle: allTask[index].taskTitle }, { headers: storedHeaders })
          .then((response) => {
            if (response.request.status === 200) {
              if (response.data.taskTitle === true) {
                taskObj.request = response.data
                taskObj.taskTitle = taskObj.taskTitle
                allTask[index] = taskObj
                e.target.blur();
                generateBeep();
                setAllTask(allTask)
                dispatch(setDispatchAllTask(allTask))
                toast.success("Request for task title change sent successfully", { toastId: 'success', autoClose: 2000 });
              } else {
                taskObj.taskTitle = e.target.value
                allTask[index] = taskObj
                e.target.blur();
                generateBeep();
                setAllTask(allTask)
                dispatch(setDispatchAllTask(allTask))
                toast.success("task title updated successfully", { toastId: 'success', autoClose: 2000 });
              }
              setAllTask(allTask)
              dispatch(setDispatchAllTask(allTask))
            }
            setAddtaskCall(false)
          })
          .catch((error) => {
            setAddtaskCall(false)
          })
      }
    }

  };

  useEffect(() => {
    setAllTask(dispatchAllTask)
  }, [dispatchAllTask, completeAnalytics])


  useEffect(() => {
    if (taskOfListPut.length !== allTask.length && selectAllCheckBox) {
      setSelectAllCheckBox(false)
    } else if (taskOfListPut.length === allTask.length && !selectAllCheckBox) {
      setSelectAllCheckBox(false)
    } else if (taskOfListPut.length === 0 && allTask.length === 0) {
      setSelectAllCheckBox(false)

    }
  }, [taskOfListPut])

  const popUpForRqt = () => {
    return setRetqMulFlag(true)
  }
  const [isAssendingName, setIsAssendingName] = useState(true);
  const [sortBy, setSortBy] = useState('')
  const handleSortByName = () => {
    setSortBy('name')
    if (isAssendingName) {
      setIsAssendingName(false)
      // toast.info("Sorted task name by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => a.taskTitle.localeCompare(b.taskTitle));
      setAllTask(sortedTasks)
    } else {
      setIsAssendingName(true)
      // toast.info("Sorted task name by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => b.taskTitle.localeCompare(a.taskTitle));
      setAllTask(sortedTasks)
    }

  }

  const [isAssendingStatus, setIsAssendingStatus] = useState(true);
  const handleSortByStatus = () => {
    setSortBy('status')
    if (isAssendingStatus) {
      setIsAssendingStatus(false)
      // toast.info("Sorted Status by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => a.statusEntity.statusLevel - b.statusEntity.statusLevel);
      setAllTask(sortedTasks)
    } else {
      setIsAssendingStatus(true)
      // toast.info("Sorted Status by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => b.statusEntity.statusLevel - a.statusEntity.statusLevel);
      setAllTask(sortedTasks)
    }

  }
  const [isAssendingPriority, setIsAssendingPriority] = useState(true);
  const handleSortByPriority = () => {
    setSortBy('priority')
    if (isAssendingPriority) {
      setIsAssendingPriority(false)
      // toast.info("Sorted Priority by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => a.priorityEntity.priorityId - b.priorityEntity.priorityId);
      setAllTask(sortedTasks)
    } else {
      setIsAssendingPriority(true)
      // toast.info("Sorted Priority by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => b.priorityEntity.priorityId - a.priorityEntity.priorityId);
      setAllTask(sortedTasks)
    }

  }
  const [isAssendingProject, setIsAssendingProject] = useState(true);
  const handleSortByProject = () => {
    setSortBy('project')
    if (isAssendingProject) {
      setIsAssendingProject(false)
      // toast.info("Sorted Project by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.projectEntity?.projectName || '';
        const projectB = b.projectEntity?.projectName || '';
        return projectA.localeCompare(projectB);
      });
      setAllTask(sortedTasks)
    } else {
      setIsAssendingProject(true)
      // toast.info("Sorted Project by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.projectEntity?.projectName || '';
        const projectB = b.projectEntity?.projectName || '';
        return projectB.localeCompare(projectA);
      });
      setAllTask(sortedTasks)
    }

  }
  const [isAssendingTime, setIsAssendingTime] = useState(true);
  const handleSortByTime = () => {
    setSortBy('time')
    if (isAssendingTime) {
      setIsAssendingTime(false)
      // toast.info("Sorted Time by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.taskTimeFrom || '';
        const projectB = b.taskTimeFrom || '';
        return projectA.localeCompare(projectB);
      });
      setAllTask(sortedTasks)
    } else {
      setIsAssendingTime(true)
      // toast.info("Sorted Time by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.taskTimeFrom || '';
        const projectB = b.taskTimeFrom || '';
        return projectB.localeCompare(projectA);
      });
      setAllTask(sortedTasks)
    }

  }
  const [isAssendingStartDate, setIsAssendingStartDate] = useState(true);
  const handleSortByStartDate = () => {
    setSortBy('startdate')
    if (isAssendingStartDate) {
      setIsAssendingStartDate(false)
      // toast.info("Sorted task Start Date by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.taskSchedule || '';
        const projectB = b.taskSchedule || '';
        return projectA.localeCompare(projectB);
      });
      setAllTask(sortedTasks)
    } else {
      setIsAssendingStartDate(true)
      // toast.info("Sorted task Start Date by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.taskSchedule || '';
        const projectB = b.taskSchedule || '';
        return projectB.localeCompare(projectA);
      });
      setAllTask(sortedTasks)
    }

  }
  const [isAssendingDueDate, setIsAssendingDueDate] = useState(true);
  const handleSortByDueDate = () => {
    setSortBy('duedate')
    if (isAssendingDueDate) {
      setIsAssendingDueDate(false)
      // toast.info("Sorted task Due Date by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.taskDueDate || '';
        const projectB = b.taskDueDate || '';
        return projectA.localeCompare(projectB);
      });
      setAllTask(sortedTasks)
    } else {
      setIsAssendingDueDate(true)
      // toast.info("Sorted task Due Date by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => {
        const projectA = a.taskDueDate || '';
        const projectB = b.taskDueDate || '';
        return projectB.localeCompare(projectA);
      });
      setAllTask(sortedTasks)
    }
  }
  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('index', index.toString());
  };

  // Function to handle drop
  const handleDrop = (e, targetIndex) => {
    const draggedIndex = parseInt(e.dataTransfer.getData('index'));
    const draggedRow = allTask[draggedIndex];

    // Remove the dragged row from the list
    const updatedRows = allTask.filter((_, index) => index !== draggedIndex);

    // Insert the dragged row at the target index
    updatedRows.splice(targetIndex, 0, draggedRow);

    setAllTask(updatedRows)
  };
  const handleAddTaskForEmp = (index) => {
    if ((allTask.length - 1) === index) {
      if (allTask.length > 0 && allTask[allTask.length - 1].taskId === null) {
        setAddtaskCall(true)
        if (allTask[allTask.length - 1].taskTitle === null || allTask[allTask.length - 1].taskTitle === '') {
          toast.error("Please enter task title", { toastId: 'success', autoClose: 2000 });
          return
        } else {
          const temp = {
            "taskTitle": [tempTaskTile],
            "employee": [selfInfoEmp.empId],
            "taskScheduleDate": fullDateF,
            "taskTags": [selfInfoEmp.department?.departmentId],
            "taskStatus": statuses[0].statusId,
            "taskPriority": priorities[0].priorityId,
          }
          axios.post(`${apiUrl}task/add`, temp, { headers: storedHeaders })
            .then((response) => {
              if (response.request.status === 201) {
                allTask[allTask.length - 1].taskId = parseInt(response.data.taskId)
                allTask[allTask.length - 1].taskTitle = tempTaskTile
                dispatch(setDispatchAllTask(allTask))
                dataObjectInit.data = allTask
                setDataObject(dataObjectInit)
                setNewTaskFlag(false)
                generateBeep();
                newTask = []
                setTempTaskTitle(null)
                setAddtaskCall(false)
                toast.success("task added successfully", { toastId: 'success', autoClose: 2000 });
              }
            })
            .catch((error) => {
              setAddtaskCall(false)

            });
        }
      }
    }
  }

  // const setDotStatusBackGround = (colorCode, alpha) => {

  //   colorCode = colorCode.replace('#', '');

  //   let r = parseInt(colorCode.substring(0, 2), 16);
  //   let g = parseInt(colorCode.substring(2, 4), 16);
  //   let b = parseInt(colorCode.substring(4, 6), 16);
  //   alpha = 0.7

  //   // Return the RGBA value
  //   return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  // }

  const [isAssendingAssignedto, setIsAssendingAssignedTo] = useState(true);
  const handleSortByAssignedto = () => {
    setSortBy('assigned')
    if (isAssendingAssignedto) {
      setIsAssendingAssignedTo(false)
      // toast.info("Sorted task name by Assending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => a.taskEmployee.empFullName.localeCompare(b.taskEmployee.empFullName));
      setAllTask(sortedTasks)
    } else {
      setIsAssendingAssignedTo(true)
      // toast.info("Sorted task name by Dessending order", { autoClose: 1500 })
      const sortedTasks = [...allTask].sort((a, b) => b.taskEmployee.empFullName.localeCompare(a.taskEmployee.empFullName));
      setAllTask(sortedTasks)
    }

  }

  const handleViewEmpSingle = (task, index) => {
    try {
      let currentTime = new Date();
      // Extract hours, minutes, and seconds
      let hours = currentTime.getHours();
      let minutes = currentTime.getMinutes();
      let seconds = currentTime.getSeconds();

      // Pad single digit values with leading zeros
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      // Format the time as "HH:mm:ss"
      let formattedTime = hours + ':' + minutes + ':' + seconds;

      // Store the formatted time in a local variable
      let localTime = formattedTime;

      allTask[index].taskView.push({
        "empId": self.empId,
        "empFullName": self.empFullName,
        "empImg": self.empImg !== null ? self.empImg : profile,
        "viewedTimeStamp": formattedTime
      });
      const splitFullDate = getFullDate.split(" ")
      const mNumber = getMonthNumber(splitFullDate[2])
      const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
      axios.post(`${apiUrl}task/update-view`, {
        empId: selfInfoEmp.empId,
        date: fullDateF,
        task: [task.taskId]
      }, {
        headers: storedHeaders
      })
        .then((response) => {
          if (response.request.status === 200) {
              toast.success('task viewed successfully', {autoClose: 2000})
              setAllTask(allTask)
              dispatch(setDispatchAllTask(allTask))
          }
        })
        .catch((err) => {
          {}
        })
    } catch {

    }
  }

  const [viewTaskId, setViewTaskId] = useState('')
  const isView = (task) => {
    var checkView = task.taskView.some((emp) => self.empId === emp.empId);
    return !checkView;
  }



  const debouncedSearch = useCallback(
    debounce(
      (searchTerm) => {
        setTaskOfListPut([]);
        if (searchTerm === "") {
          getAllTaskList(); // Ensure this fetches all tasks
          return;
        }

        axios
          .post(
            `${url}project/task/get/all-search`,
            { key: searchTerm, projectId: project.projectId },
            { headers: storedHeaders }
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(setDispatchAllTask(response.data.data));
              setAllTask(response.data.data);
              setIsLastPage(true);
              setTaskOfListPut([]);
              setTaskSeletedCount(0);
            }
          })
          .catch((err) => {
            console.error("Error fetching tasks:", err);
            setTaskOfListPut([]);
            setTaskSeletedCount(0);
          });
      },
      2000 // Delay in milliseconds (3 seconds)
    ),
    []
  );

  // Search Handler
  const handleSearchProjectAllTask = (event) => {
    const searchTerm = event.target.value;
    setTaskSearchKey(searchTerm);
    debouncedSearch(searchTerm);
  };

 

  const handleSearchEmpTrns = (e) => {
    setTAList(true)
    const searchQuery = e.target.value.toLowerCase();
    const results = dAssignees.filter(employee =>
      employee.empFullName.toLowerCase().includes(searchQuery));

    if (e.target.value === '') {
      setUpdatedTranferList(dAssignees)
    } else {
      if (results.length === 0) {
        setTAList(false)
      } else {
        setUpdatedTranferList(results)
      }
    }
  }
  // const debouncedSearchProjectAllTasks = debounce(5000, handleSearchProjectAllTask);

  const [clicked, setClicked] = useState(false)


  const [tempIndex, setTempIndex] = useState(null)
  const handleStartTime = (time, stringTime) => {
    let hour = time.$H < 10 ? '0' + time.$H : time.$H
    let minute = time.$m < 10 ? '0' + time.$m : time.$m
    let seconds = time.$s < 10 ? '0' + time.$s : time.$s
    let temptimeString = `${hour}:${minute}:${seconds}`;
    axios.put(`${apiUrl}task/update`, { "taskId": allTask[tempIndex].taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTimeFrom": temptimeString }, { headers: storedHeaders })
      .then(response => {
        if (response.request.status === 200) {
          allTask[tempIndex].taskTimeFrom = temptimeString
          setAllTask(allTask)
          dispatch(setDispatchAllTask(allTask))
          toast.success('Start time update successfully', { autoClose: 2000 })

        }
      })
      .catch(error => {
        toast.error('error occured', { autoClose: 2000 })
      })
  };


  const handleEndTime = (time, stringTime) => {
    let hour = time.$H < 10 ? '0' + time.$H : time.$H
    let minute = time.$m < 10 ? '0' + time.$m : time.$m
    let seconds = time.$s < 10 ? '0' + time.$s : time.$s
    let temptimeString = `${hour}:${minute}:${seconds}`;
    axios.put(`${apiUrl}task/update`, { "taskId": allTask[tempIndex].taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTimeTo": temptimeString }, { headers: storedHeaders })
      .then(response => {
        if (response.request.status === 200) {
          allTask[tempIndex].taskTimeTo = temptimeString
          setAllTask(allTask)
          dispatch(setDispatchAllTask(allTask))
          toast.success('End time update successfully', { autoClose: 2000 })
        }
      })
      .catch(error => {
        toast.error('error occured', { autoClose: 2000 })
      })
  }

  function convertTimeFormat(timeString) {
    const [hours, minutes] = timeString.split(':');

    let hourNum = parseInt(hours, 10);
    const ampm = hourNum >= 12 ? 'pm' : 'am';

    hourNum = hourNum % 12;
    hourNum = hourNum === 0 ? 12 : hourNum;

    const hourStr = hourNum < 10 ? '0' + hourNum : hourNum;
    let minuteStr = ''
    if (minutes === '00') {
      minuteStr = '00'
    } else {  
      minuteStr = minutes < 10 && minutes !== 0 ? '' + minutes : minutes;
    }
    return hourStr + ':' + minuteStr + ' ' + ampm;
  }


  function extractPlainText(html) {
    // Replace closing tags with closing tags followed by newline character
    try {
      const replacedHtml = html.replace(/<\/(p|h2|h3|h4)>/g, '</$1>\n');
      // Convert HTML to plain text
      const doc = new DOMParser().parseFromString(replacedHtml, 'text/html');
      return doc.body.textContent || '';
    }catch {
    }
  }

  const removeStringParse = (e) => {
    let jsonString = e;
    var jsonObject = null 
    try {
      jsonObject = JSON.parse(jsonString);
    }catch {
      jsonObject = {"editorData" : `${jsonString}`, "plainData" : `${jsonString}`}
    }
  return jsonObject.editorData
}


const [isAssendingDepartment, setIsAssendingDepartment] = useState(true)
const handleSortByDepartment = () => {
  setSortBy('department')
  if(isAssendingDepartment){
      setIsAssendingDepartment(false)
      const sortedTasks = allTask.sort((a, b) => {
      const departmentNameA = a.tags && a.tags[0] ? a.tags[0].departmentName.toLowerCase() : '';
      const departmentNameB = b.tags && b.tags[0] ? b.tags[0].departmentName.toLowerCase() : '';
      
      if (departmentNameA < departmentNameB) {
        return -1;
      }
      if (departmentNameA > departmentNameB) {
        return 1;
      }
      return 0;
    });
    setAllTask([...sortedTasks]);
    dispatch(setDispatchAllTask([...sortedTasks]));
}else{
    setIsAssendingDepartment(true)
    const sortedTasks = allTask.sort((a, b) => {
      const departmentNameA = a.tags && a.tags[0] ? a.tags[0].departmentName.toLowerCase() : '';
      const departmentNameB = b.tags && b.tags[0] ? b.tags[0].departmentName.toLowerCase() : '';
      if (departmentNameA > departmentNameB) {
        return -1;
      }
      if (departmentNameA < departmentNameB) {
        return 1;
      }
      return 0;
    });
    setAllTask([...sortedTasks]);
    dispatch(setDispatchAllTask([...sortedTasks]));
}

}

const isTagInList = (tagObj, index) => {
  return allTask[index].tags.some(tag => tag.departmentId === tagObj.departmentId);
}

const dayViewContentRef = useRef(null);
const [checkHeight, setCheckHeight] = useState(0)
const handleCheckHeight = (event) => {
      const clickY = event?.clientY;
      const divTopOffset = dayViewContentRef?.current?.getBoundingClientRect()?.top;
      const heightUpToClick = clickY - divTopOffset;
      setCheckHeight(parseInt(heightUpToClick));
};
  return (
    <div className="viewsAllTask">
      <div className='prjAllTskHeader'>
        <div className="PrjNameHolder">
          <div className="prjallTskName">
            {`${project?.projectName} >`}
          </div>

          <div className="prjallTskName" style={{ color: 'rgba(38, 50, 56, 1)' }}>
            &nbsp;All Tasks
          </div>
        </div>
        <div className="searchPrjTsk">
          <input className="searcjInputTag" type="text" value={taskSearchKey} placeholder="Search tasks..." onChange={(e) => {
            // debouncedSearchProjectAllTasks(e.target.value)
            // setTaskSearchKey(e.target.value)
            handleSearchProjectAllTask(e)
            setSelectAllCheckBox(false)
            setTaskOfListPut([])
            setTaskSeletedCount(0)
            }} />
         {/* {(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") && <button className="prjAddTask" onClick={() => { dispatch(setAddTask(true)) }}>Add Task</button> } */}
        </div>
      </div>
      <div className="TaskViewPrjAllTask_MainCtn">
        <div className="DayViewProgressHeader">
          <div className="DayViewActualProgressContent">
            {taskSelectedCount === 0 &&
              <div className="DayViewActualProgressContentView">
                <p>{dispatchAllTask?.filter(taskObj => taskObj?.taskDone === 1).length !== 0 ? `${parseInt((dispatchAllTask?.filter(taskObj => taskObj?.taskDone === 1).length / dispatchAllTask?.length) * 100)}%` : "0%"}</p>
                <p>{dispatchAllTask?.length > 0 ? `${dispatchAllTask?.filter(taskObj => taskObj.taskDone === 1).length}/${dispatchAllTask.length}` : '0/0'}</p>
                <div className="DayViewProgressResult">
                  <div style={{ width: dispatchAllTask?.length > 0 ? `${parseInt((dispatchAllTask?.filter(taskObj => taskObj.taskDone === 1).length / dispatchAllTask?.length) * 100)}%` : '0%', height: '100%', backgroundColor: 'rgba(1, 159, 55, 1)', borderRadius: '50px' }}></div>
                </div>
              </div>
            }
          </div>

          {taskSelectedCount > 0 &&
            <div className="taskCrudOperations">
              <div className="SeletedTaskCount" style={{ borderRadius: '4px 0px 0px 4px', color: taskSelectedCount > 0 ? 'rgba(0, 95, 182, 1)' : '#6c7e87' }}>
                {taskOfListPut.length}&nbsp;Selected
              </div>

              <div className="crudOnStatus" onClick={() => setStatusHeaderList(!headerStatusList)}>
                <div className="crudOperationDiv">
                  <svg width="8" height="5" viewBox="0 0 8 5" fill=" none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.98274 0.193664C7.03967 0.130485 7.1071 0.0808329 7.1811 0.0476071C7.2551 0.0143814 7.33419 -0.00175171 7.41373 0.000150631C7.49328 0.00205298 7.5717 0.0219526 7.6444 0.0586868C7.71711 0.095421 7.78264 0.148253 7.83718 0.214098C7.89172 0.279942 7.93417 0.357478 7.96204 0.442177C7.98992 0.526875 8.00266 0.617038 7.99954 0.707399C7.99641 0.797759 7.97747 0.886505 7.94383 0.968453C7.91018 1.0504 7.86251 1.12391 7.80359 1.18468L4.41002 4.81477C4.29916 4.93373 4.15247 5 4 5C3.84753 5 3.70084 4.93373 3.58998 4.81477L0.196414 1.18468C0.137494 1.12391 0.0898187 1.0504 0.0561743 0.968453C0.0225299 0.886505 0.0035907 0.797759 0.000462925 0.707399C-0.00266485 0.617038 0.0100816 0.526875 0.0379576 0.442177C0.0658336 0.357478 0.10828 0.279942 0.162818 0.214098C0.217356 0.148253 0.282892 0.095421 0.355597 0.0586868C0.428302 0.0219526 0.506718 0.00205298 0.586266 0.000150631C0.665814 -0.00175171 0.744897 0.0143814 0.818898 0.0476071C0.892898 0.0808329 0.960331 0.130485 1.01726 0.193664L3.9996 3.38451L6.98274 0.193664Z" fill="#263238" />
                  </svg>
                  <p>Status</p>
                </div>

                {headerStatusList &&
                  <div className="listOfStatusWrapperForHeader list" style={{ zIndex: 1000 }} ref={headerStatusListRef}>

                    {(self.role[0].role !== "ROLE_SUPERADMIN" || self.role[0].role !== "ROLE_ADMIN") && (
                      <div className="listOfStatusWrapper" style={{ zIndex: 1000 }} ref={headerStatusListRef}>
                        {statuses && statuses.length > 0 && statuses.map((statusObj) => (
                          (statusObj.statusId !== 6) && (
                            <div style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={statusObj ? () => UPDATE_MULTIPLE(0, statusObj) : null}>
                              {statusObj.status}
                            </div>
                          )
                        ))}
                      </div>
                    )}

                    {(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") && (
                      <div className="listOfStatusWrapper" style={{ zIndex: 1000 }} ref={headerStatusListRef}>
                        {statuses && statuses.length > 0 && statuses.map((statusObj) => (
                          <div style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={statusObj ? () => UPDATE_MULTIPLE(0, statusObj) : null}>
                            {statusObj.status}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                }
              </div>

              <div className="crudOnPriority" onClick={() => { setPriorityHeaderList(!headerPriorityList) }}>
                <div className="crudOperationDiv">
                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.98274 0.193664C7.03967 0.130485 7.1071 0.0808329 7.1811 0.0476071C7.2551 0.0143814 7.33419 -0.00175171 7.41373 0.000150631C7.49328 0.00205298 7.5717 0.0219526 7.6444 0.0586868C7.71711 0.095421 7.78264 0.148253 7.83718 0.214098C7.89172 0.279942 7.93417 0.357478 7.96204 0.442177C7.98992 0.526875 8.00266 0.617038 7.99954 0.707399C7.99641 0.797759 7.97747 0.886505 7.94383 0.968453C7.91018 1.0504 7.86251 1.12391 7.80359 1.18468L4.41002 4.81477C4.29916 4.93373 4.15247 5 4 5C3.84753 5 3.70084 4.93373 3.58998 4.81477L0.196414 1.18468C0.137494 1.12391 0.0898187 1.0504 0.0561743 0.968453C0.0225299 0.886505 0.0035907 0.797759 0.000462925 0.707399C-0.00266485 0.617038 0.0100816 0.526875 0.0379576 0.442177C0.0658336 0.357478 0.10828 0.279942 0.162818 0.214098C0.217356 0.148253 0.282892 0.095421 0.355597 0.0586868C0.428302 0.0219526 0.506718 0.00205298 0.586266 0.000150631C0.665814 -0.00175171 0.744897 0.0143814 0.818898 0.0476071C0.892898 0.0808329 0.960331 0.130485 1.01726 0.193664L3.9996 3.38451L6.98274 0.193664Z" fill="#263238" />
                  </svg>
                  <p>Priority</p>
                </div>

                {headerPriorityList &&
                  <div className="listOfProrityWrapper listOfPriorityWrapperForHeader" style={{ zIndex: 1000 }} ref={priorityStatusListRef}>
                    {priorities && priorities.length > 0 && priorities.map((priorityObj) => (
                      <div style={{ backgroundColor: `${priorityObj.priorityColorCode}` }} onClick={() => UPDATE_MULTIPLE(1, priorityObj)}>{priorityObj.priority}</div>
                    ))}
                  </div>
                }
              </div>

              <div className="crudOnDueDate" >
                <div className="crudOperationDiv" onClick={() => {
                  setDueDatePut(fullDateForDue)
                  setHeaderDueDatCal(!headerDudateCalender)
                }}>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.07494 1.4966C1.60698 1.56103 1.33745 1.68185 1.14076 1.88337C0.943898 2.08472 0.825663 2.36084 0.762725 2.83988C0.698438 3.32918 0.697697 3.9742 0.697697 4.88206V5.83435C0.697697 6.74221 0.698438 7.38723 0.762725 7.87653C0.825663 8.35557 0.943688 8.63147 1.14055 8.83282C1.33724 9.03434 1.60698 9.15538 2.07494 9.21981C2.55292 9.28562 3.18303 9.28638 4.0699 9.28638H5.93042C6.81729 9.28638 7.44739 9.28562 7.92538 9.21981C8.39333 9.15538 8.66286 9.03456 8.85955 8.83304C9.05642 8.63169 9.17465 8.35557 9.23759 7.87653C9.30188 7.38723 9.30262 6.74221 9.30262 5.83435V4.88206C9.30262 3.9742 9.30188 3.32918 9.23759 2.83988C9.17465 2.36084 9.05663 2.08494 8.85976 1.88359C8.66307 1.68206 8.39333 1.56103 7.92538 1.4966C7.44739 1.43079 6.81729 1.43003 5.93042 1.43003H4.0699C3.18303 1.43003 2.55292 1.43079 2.07494 1.4966ZM4.04365 0.71582H5.95667C6.81141 0.715813 7.48849 0.715807 8.01838 0.788762C8.5636 0.863828 9.00496 1.02198 9.3529 1.37835C9.70117 1.73456 9.85571 2.18643 9.92906 2.74467C10.0003 3.28711 10.0003 3.98022 10.0003 4.85518V5.86123C10.0003 6.73619 10.0003 7.4293 9.92906 7.97173C9.85572 8.52992 9.7012 8.98176 9.353 9.33796C9.00505 9.6944 8.56365 9.85257 8.01838 9.92765C7.48849 10.0006 6.81141 10.0006 5.95668 10.0006H4.04364C3.1889 10.0006 2.51182 10.0006 1.98194 9.92765C1.4366 9.85256 0.995178 9.69436 0.647204 9.33785C0.29908 8.98167 0.144585 8.52986 0.071255 7.97173C-1.30996e-05 7.4293 -7.22501e-06 6.73619 1.49565e-07 5.86122V4.85519C-7.22501e-06 3.98022 -1.30996e-05 3.28711 0.071255 2.74467C0.144593 2.18649 0.299111 1.73465 0.647309 1.37845C0.995267 1.02201 1.43666 0.863836 1.98194 0.788762C2.51183 0.715807 3.18891 0.715813 4.04365 0.71582Z" fill="#263238" />
                    <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M2.67631 0C2.86898 0 3.02516 0.159882 3.02516 0.357106V1.07132C3.02516 1.26854 2.86898 1.42843 2.67631 1.42843C2.48365 1.42843 2.32746 1.26854 2.32746 1.07132V0.357106C2.32746 0.159882 2.48365 0 2.67631 0ZM7.32762 0C7.52029 0 7.67647 0.159882 7.67647 0.357106V1.07132C7.67647 1.26854 7.52029 1.42843 7.32762 1.42843C7.13496 1.42843 6.97877 1.26854 6.97877 1.07132V0.357106C6.97877 0.159882 7.13496 0 7.32762 0ZM0.234375 3.45203C0.234375 3.2548 0.39056 3.09492 0.583223 3.09492H9.42071C9.61337 3.09492 9.76956 3.2548 9.76956 3.45203C9.76956 3.64925 9.61337 3.80914 9.42071 3.80914H0.583223C0.39056 3.80914 0.234375 3.64925 0.234375 3.45203Z" fill="#263238" />
                    <path d="M7.79056 7.26157C7.79056 7.38785 7.74155 7.50896 7.65432 7.59825C7.56709 7.68755 7.44878 7.73771 7.32542 7.73771C7.20206 7.73771 7.08376 7.68755 6.99653 7.59825C6.9093 7.50896 6.86029 7.38785 6.86029 7.26157C6.86029 7.13529 6.9093 7.01418 6.99653 6.92489C7.08376 6.83559 7.20206 6.78543 7.32542 6.78543C7.44878 6.78543 7.56709 6.83559 7.65432 6.92489C7.74155 7.01418 7.79056 7.13529 7.79056 7.26157ZM7.79056 5.357C7.79056 5.48328 7.74155 5.60439 7.65432 5.69368C7.56709 5.78298 7.44878 5.83314 7.32542 5.83314C7.20206 5.83314 7.08376 5.78298 6.99653 5.69368C6.9093 5.60439 6.86029 5.48328 6.86029 5.357C6.86029 5.23072 6.9093 5.10961 6.99653 5.02032C7.08376 4.93102 7.20206 4.88086 7.32542 4.88086C7.44878 4.88086 7.56709 4.93102 7.65432 5.02032C7.74155 5.10961 7.79056 5.23072 7.79056 5.357ZM5.4649 7.26157C5.4649 7.38785 5.4159 7.50896 5.32867 7.59825C5.24144 7.68755 5.12313 7.73771 4.99977 7.73771C4.87641 7.73771 4.7581 7.68755 4.67087 7.59825C4.58364 7.50896 4.53464 7.38785 4.53464 7.26157C4.53464 7.13529 4.58364 7.01418 4.67087 6.92489C4.7581 6.83559 4.87641 6.78543 4.99977 6.78543C5.12313 6.78543 5.24144 6.83559 5.32867 6.92489C5.4159 7.01418 5.4649 7.13529 5.4649 7.26157ZM5.4649 5.357C5.4649 5.48328 5.4159 5.60439 5.32867 5.69368C5.24144 5.78298 5.12313 5.83314 4.99977 5.83314C4.87641 5.83314 4.7581 5.78298 4.67087 5.69368C4.58364 5.60439 4.53464 5.48328 4.53464 5.357C4.53464 5.23072 4.58364 5.10961 4.67087 5.02032C4.7581 4.93102 4.87641 4.88086 4.99977 4.88086C5.12313 4.88086 5.24144 4.93102 5.32867 5.02032C5.4159 5.10961 5.4649 5.23072 5.4649 5.357ZM3.13925 7.26157C3.13925 7.38785 3.09024 7.50896 3.00301 7.59825C2.91578 7.68755 2.79748 7.73771 2.67412 7.73771C2.55075 7.73771 2.43245 7.68755 2.34522 7.59825C2.25799 7.50896 2.20898 7.38785 2.20898 7.26157C2.20898 7.13529 2.25799 7.01418 2.34522 6.92489C2.43245 6.83559 2.55075 6.78543 2.67412 6.78543C2.79748 6.78543 2.91578 6.83559 3.00301 6.92489C3.09024 7.01418 3.13925 7.13529 3.13925 7.26157ZM3.13925 5.357C3.13925 5.48328 3.09024 5.60439 3.00301 5.69368C2.91578 5.78298 2.79748 5.83314 2.67412 5.83314C2.55075 5.83314 2.43245 5.78298 2.34522 5.69368C2.25799 5.60439 2.20898 5.48328 2.20898 5.357C2.20898 5.23072 2.25799 5.10961 2.34522 5.02032C2.43245 4.93102 2.55075 4.88086 2.67412 4.88086C2.79748 4.88086 2.91578 4.93102 3.00301 5.02032C3.09024 5.10961 3.13925 5.23072 3.13925 5.357Z" fill="#FF8402" />
                  </svg>
                  <p>Due Date</p>
                </div>
                {headerDudateCalender &&
                  <div className='calender-holder-dashboard dueDate-calender-for-day' ref={headerDueDateRef}>
                    <Calendar value={routeDateDue} inline onChange={(e) => {
                      setRouteDateDue(e.target.value)
                      const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                      setDueDatePut(formattedDate)
                      UPDATE_MULTIPLE(2, formattedDate)
                      setRouteDateDue("")
                    }} unstyled={false} />
                  </div>
                }
              </div>

              {/* <div className="crudOnVerified" onClick={() => setVerifiedHeaderList(!headerVerifiedList)}>
                <div className="crudOperationDiv">
                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.98274 0.193664C7.03967 0.130485 7.1071 0.0808329 7.1811 0.0476071C7.2551 0.0143814 7.33419 -0.00175171 7.41373 0.000150631C7.49328 0.00205298 7.5717 0.0219526 7.6444 0.0586868C7.71711 0.095421 7.78264 0.148253 7.83718 0.214098C7.89172 0.279942 7.93417 0.357478 7.96204 0.442177C7.98992 0.526875 8.00266 0.617038 7.99954 0.707399C7.99641 0.797759 7.97747 0.886505 7.94383 0.968453C7.91018 1.0504 7.86251 1.12391 7.80359 1.18468L4.41002 4.81477C4.29916 4.93373 4.15247 5 4 5C3.84753 5 3.70084 4.93373 3.58998 4.81477L0.196414 1.18468C0.137494 1.12391 0.0898187 1.0504 0.0561743 0.968453C0.0225299 0.886505 0.0035907 0.797759 0.000462925 0.707399C-0.00266485 0.617038 0.0100816 0.526875 0.0379576 0.442177C0.0658336 0.357478 0.10828 0.279942 0.162818 0.214098C0.217356 0.148253 0.282892 0.095421 0.355597 0.0586868C0.428302 0.0219526 0.506718 0.00205298 0.586266 0.000150631C0.665814 -0.00175171 0.744897 0.0143814 0.818898 0.0476071C0.892898 0.0808329 0.960331 0.130485 1.01726 0.193664L3.9996 3.38451L6.98274 0.193664Z" fill="#263238" />
                  </svg>
                  <p>Verified</p>
                </div>
  
                {headerVerifiedList &&
                  <div className="listOfVerifiedWrapper listOfVerifiedWrapperForHeader" style={{ zIndex: 1000 }} ref={headerVerifiedListRef}>
                    {verifieses && verifieses.length > 0 && verifieses.map((verifiedObj) => (
                      <div style={{ backgroundColor: setVerifiedBackgournd(verifiedObj.verificationStatusId) }} onClick={() => handlePutStatusList(taskOfListPut, verifiedObj.verificationStatusId, 3)}>{verifiedObj.verificationStatus}</div>
                    ))}
                  </div>
                }
              </div> */}

              {/* <div className="crudOnDuplicate" >
                <div className="crudOperationDiv" onClick={() => {
                  setdateForDuplicate(fullDateForDue)
                  setHeaderDuplicateCal(!headerDuplicate)
                }}>
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.84375 0.8125L2.84255 0.812504C2.30464 0.814093 1.78921 1.02848 1.40885 1.40885C1.02848 1.78921 0.81409 2.30464 0.8125 2.84255V8.32813V8.32928C0.813879 8.8134 1.0068 9.2773 1.34913 9.61962C1.69145 9.96195 2.15535 10.1549 2.63947 10.1562L2.64062 10.1563H2.84375V10.334C2.84375 11.3577 3.6736 12.1875 4.69727 12.1875H10.334C11.3577 12.1875 12.1875 11.3577 12.1875 10.334V4.69727C12.1875 3.6736 11.3577 2.84375 10.334 2.84375H10.1522L10.1563 2.64909L10.1562 2.63947C10.1549 2.15535 9.96194 1.69146 9.61962 1.34913C9.2773 1.00681 8.8134 0.813881 8.32928 0.8125H2.84375ZM9.7392 3.65625C9.73805 3.65625 9.73689 3.65625 9.73574 3.65625H4.69727C4.12233 3.65625 3.65625 4.12233 3.65625 4.69727V9.75V10.334C3.65625 10.9089 4.12233 11.375 4.69727 11.375H10.334C10.9089 11.375 11.375 10.9089 11.375 10.334V4.69727C11.375 4.12233 10.9089 3.65625 10.334 3.65625H9.7392ZM2.84375 9.34375V4.69727C2.84375 3.6736 3.6736 2.84375 4.69727 2.84375H9.33943L9.34373 2.63735C9.34181 2.36952 9.23457 2.11313 9.0451 1.92366C8.8547 1.73326 8.59674 1.62591 8.3275 1.625H2.84439C2.52133 1.6261 2.21182 1.75492 1.98337 1.98337C1.75492 2.21182 1.6261 2.52134 1.625 2.84439V8.3275C1.62591 8.59674 1.73326 8.8547 1.92365 9.0451C2.11403 9.23547 2.37196 9.34283 2.64117 9.34375H2.84375ZM7.92188 5.48438C7.92188 5.26001 7.73999 5.07813 7.51562 5.07813C7.29126 5.07813 7.10938 5.26001 7.10938 5.48438V7.10938H5.48438C5.26001 7.10938 5.07812 7.29126 5.07812 7.51563C5.07812 7.73999 5.26001 7.92188 5.48438 7.92188H7.10938V9.54688C7.10938 9.77124 7.29126 9.95313 7.51562 9.95313C7.73999 9.95313 7.92188 9.77124 7.92188 9.54688V7.92188H9.54688C9.77124 7.92188 9.95312 7.73999 9.95312 7.51563C9.95312 7.29126 9.77124 7.10938 9.54688 7.10938H7.92188V5.48438Z" fill="#263238" />
                  </svg>
                  <p>Duplicate</p>
                </div>

                {headerDuplicate &&
                  <div className='calender-holder-dashboard duplicate-calender-holder-dashboard ' ref={headerDuplicateRef}>
                    <Calendar value={routeDateDuplicate} inline onChange={(e) => {
                      setRouteDateDuplicate(e.target.value)
                      const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                      UPDATE_MULTIPLE(3, formattedDate)
                      setRouteDateDuplicate("")
                    }} unstyled={false} />
                  </div>
                }
              </div> */}

              <div className="crudOnDelete" style={{ borderRadius: '0px 4px 4px 0px' }} onClick={() => {
                setDeleteTaskFlag(true)
              }}>
                <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 2.5H6C6 2.23478 5.89464 1.98043 5.70711 1.79289C5.51957 1.60536 5.26522 1.5 5 1.5C4.73478 1.5 4.48043 1.60536 4.29289 1.79289C4.10536 1.98043 4 2.23478 4 2.5ZM3.25 2.5C3.25 2.27019 3.29526 2.04262 3.38321 1.8303C3.47116 1.61798 3.60006 1.42507 3.76256 1.26256C3.92507 1.10006 4.11798 0.971157 4.3303 0.883211C4.54262 0.795265 4.77019 0.75 5 0.75C5.22981 0.75 5.45738 0.795265 5.6697 0.883211C5.88202 0.971157 6.07493 1.10006 6.23744 1.26256C6.39994 1.42507 6.52884 1.61798 6.61679 1.8303C6.70474 2.04262 6.75 2.27019 6.75 2.5H9.625C9.72446 2.5 9.81984 2.53951 9.89017 2.60983C9.96049 2.68016 10 2.77554 10 2.875C10 2.97446 9.96049 3.06984 9.89017 3.14017C9.81984 3.21049 9.72446 3.25 9.625 3.25H8.965L8.38 9.3055C8.33512 9.76949 8.11902 10.2001 7.77384 10.5134C7.42866 10.8267 6.97915 11.0002 6.513 11H3.487C3.02093 11.0001 2.57155 10.8265 2.22647 10.5132C1.8814 10.2 1.66537 9.7694 1.6205 9.3055L1.035 3.25H0.375C0.275544 3.25 0.180161 3.21049 0.109835 3.14017C0.0395088 3.06984 0 2.97446 0 2.875C0 2.77554 0.0395088 2.68016 0.109835 2.60983C0.180161 2.53951 0.275544 2.5 0.375 2.5H3.25ZM4.25 4.875C4.25 4.77554 4.21049 4.68016 4.14016 4.60984C4.06984 4.53951 3.97446 4.5 3.875 4.5C3.77554 4.5 3.68016 4.53951 3.60984 4.60984C3.53951 4.68016 3.5 4.77554 3.5 4.875V8.625C3.5 8.72446 3.53951 8.81984 3.60984 8.89017C3.68016 8.96049 3.77554 9 3.875 9C3.97446 9 4.06984 8.96049 4.14016 8.89017C4.21049 8.81984 4.25 8.72446 4.25 8.625V4.875ZM6.125 4.5C6.22446 4.5 6.31984 4.53951 6.39016 4.60984C6.46049 4.68016 6.5 4.77554 6.5 4.875V8.625C6.5 8.72446 6.46049 8.81984 6.39016 8.89017C6.31984 8.96049 6.22446 9 6.125 9C6.02554 9 5.93016 8.96049 5.85984 8.89017C5.78951 8.81984 5.75 8.72446 5.75 8.625V4.875C5.75 4.77554 5.78951 4.68016 5.85984 4.60984C5.93016 4.53951 6.02554 4.5 6.125 4.5ZM2.367 9.2335C2.39397 9.51182 2.52362 9.77013 2.73068 9.95805C2.93775 10.146 3.20737 10.2501 3.487 10.25H6.513C6.79263 10.2501 7.06225 10.146 7.26932 9.95805C7.47638 9.77013 7.60603 9.51182 7.633 9.2335L8.212 3.25H1.788L2.367 9.2335Z" fill="#263238" />
                </svg>
                <p>Delete</p>
              </div>


              {/* <div className="crudOnDuplicate" >
                <div className="crudOperationDiv" onClick={() => setHeaderShiftTask(!headerShiftTask)}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3.89494" y="0.539474" width="7.56579" height="7.56579" rx="1.38158" stroke="#263238" strokeWidth="0.921053" />
                    <rect x="0.539474" y="3.89494" width="7.56579" height="7.56579" rx="1.38158" stroke="#263238" stroke-opacity="0.4" strokeWidth="0.921053" />
                    <path d="M1.62413 9.82016L2.34125 9.09071L1.94979 8.703L3.50736 8.53966L3.35904 10.0987L2.96758 9.71103L2.25046 10.4405L1.62413 9.82016Z" fill="#263238" />
                  </svg>
                  <p>Shift</p>
                </div>
                {headerShiftTask &&
                  <div className='calender-holder-dashboard duplicate-calender-holder-dashboard' ref={headerShiftRef}>
                    <Calendar value={routeDateShift} inline onChange={(e) => {
                      setRouteDateShift(e.target.value)
                      const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                      UPDATE_MULTIPLE(5, formattedDate)
                      setRouteDateShift("")

                    }} unstyled={false} />
                  </div>
                }
              </div> */}

              {/* <div className="crudOnDuplicate" onClick={() => {
                setTransforTaskPopUp(true)
                setUpdatedTranferList(dAssignees)
                setUpdatedTranferList(prevList => {
                  if (empInfo) {
                    return prevList.filter(item => parseInt(item.empId) !== empInfo.empId);
                  } else {
                    return prevList.filter(item => parseInt(item.empId) !== self.empId);
                  }
                });
              }}>
                <div className="crudOperationDiv" >
                  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.81275 0.534857C9.72435 0.569993 9.60128 0.687298 9.54372 0.791314C9.50486 0.861505 9.49704 0.990868 9.48963 1.68682L9.48096 2.5003H7.68675C5.93806 2.5003 5.88961 2.50172 5.77755 2.55594C5.55156 2.66535 5.44281 2.93668 5.53168 3.16935C5.5827 3.30297 5.72552 3.44497 5.84157 3.47745C5.88266 3.48894 6.86373 3.49835 8.02174 3.49835C10.078 3.49835 10.1294 3.49706 10.22 3.44366C10.2711 3.41358 10.351 3.34172 10.3977 3.28394L10.4827 3.17894L10.4963 2.70264L10.51 2.22634L11.6447 3.36141L12.7794 4.49647L11.6379 5.63799L10.4963 6.77951L10.4957 6.34207C10.4951 5.83935 10.4661 5.73534 10.2895 5.60064L10.1862 5.52178L7.34894 5.51456L4.51173 5.50737L4.50306 4.69425C4.49445 3.88501 4.49406 3.88058 4.42595 3.75893C4.30843 3.54904 4.03868 3.45408 3.80574 3.54062C3.69092 3.58325 0.112694 7.16306 0.0488462 7.29913C-0.0162593 7.43795 -0.0162866 7.57038 0.0487915 7.70928C0.0836821 7.78379 0.678135 8.3949 1.9144 9.6272C3.86644 11.573 3.80331 11.5182 4.06217 11.489C4.20201 11.4733 4.35453 11.3646 4.43971 11.2201C4.49048 11.1339 4.49502 11.0693 4.50306 10.3138L4.51173 9.5003H6.30594C8.05463 9.5003 8.10308 9.49888 8.21514 9.44465C8.44113 9.33525 8.54988 9.06392 8.46101 8.83125C8.40999 8.69762 8.26717 8.55563 8.15113 8.52314C8.11003 8.51166 7.12896 8.50225 5.97096 8.50225C3.91465 8.50225 3.86333 8.50354 3.77268 8.55694C3.72163 8.58702 3.64165 8.65888 3.59495 8.71665L3.51002 8.82165L3.49635 9.29795L3.48267 9.77426L2.34799 8.63919L1.21331 7.50412L2.35483 6.3626L3.49635 5.22108L3.49695 5.65853C3.49763 6.16124 3.52656 6.26526 3.70315 6.39995L3.80653 6.47881L6.64375 6.48603L9.48096 6.49322L9.48963 7.30635C9.49824 8.11558 9.49863 8.12001 9.56674 8.24167C9.68426 8.45156 9.95401 8.54652 10.187 8.45998C10.3018 8.41735 13.88 4.83753 13.9438 4.70147C14.0065 4.56787 14.0098 4.44526 13.9544 4.31095C13.8963 4.17015 10.364 0.629302 10.2092 0.556704C10.0906 0.50106 9.92125 0.491708 9.81275 0.534857Z" fill="black" />
                  </svg>
                  <p>Transfer</p>
                </div>
              </div> */}

            </div>
          }

          <div className="viewBtns viewDayView-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="refresh-icon"
              className={isRotating ? "rotateRefresh" : ""}
              onClick={
                () => {
                  setTaskSearchKey('')
                  setSortBy('')
                  setRotating(true)
                  dispatch(setLoader(true))
                  const splitFullDate = getFullDate.split(" ")
                  const mNumber = getMonthNumber(splitFullDate[2])
                  const fullDateF = splitFullDate[3] + "-" + (mNumber.length > 1 ? mNumber : '0' + mNumber) + "-" + splitFullDate[1]
                  setFullDate(fullDateF)
                  setFullDateForDue(fullDateF)
                  const stringHeaders = window.localStorage.getItem('myHeaders');
                  const storedHeaders = JSON.parse(stringHeaders);
                  axios.post(`${apiUrl}project/task/get/all?page=${0}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
                  .then(response => {
                    if (response) {
                      dispatch(setReset(0))
                      var completedTaskCount = response.data.data?.filter(taskObj => taskObj.taskDone === 1).length;
                      setTotalAnalyatics(response.data.data.length)
                      setCompleteAnalytics(completedTaskCount);
                      setAllTask(response.data.data)
                      setSelectAllCheckBox(false)
                      dispatch(setDispatchAllTask(response.data.data))
                      dispatch(setDataObject(response.data))
                      setPriorityOption(false)
                      setStatusOption(false)
                      setTaskOfListPut([])
                      setSelectAllCheckBox(false)
                      setIsLastPage(response.data.isLastPage)
                      setTaskSeletedCount(0)
                      setTaskListMultiplePut([])
                      dispatch(setLoader(true))
                      setRotating(false)
                      setTimeout(() => {
                        dispatch(setLoader(false))
                      }, 500);
                    }
                  })

                  .catch(err => {
                    dispatch(setLoader(false))
                    setTaskOfListPut([])
                    setSelectAllCheckBox(false)

                  })
                  
                }
              }>
              <path d="M1 4V10H7" stroke="grey" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M23 20V14H17" stroke="grey" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M20.49 8.99959C19.9828 7.56637 19.1209 6.28499 17.9845 5.27501C16.8482 4.26502 15.4745 3.55935 13.9917 3.22385C12.5089 2.88834 10.9652 2.93393 9.50481 3.35636C8.04437 3.77879 6.71475 4.5643 5.64 5.63959L1 9.99959M23 13.9996L18.36 18.3596C17.2853 19.4349 15.9556 20.2204 14.4952 20.6428C13.0348 21.0652 11.4911 21.1108 10.0083 20.7753C8.52547 20.4398 7.1518 19.7342 6.01547 18.7242C4.87913 17.7142 4.01717 16.4328 3.51 14.9996" stroke="grey" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

          </div>
        </div>

        <div className="DayView_Content_Container" ref={dayViewContentRef} >
          <div className="DayViewScroller">
            <TableContainer component={Paper} className="TableScroller">
              <Table className={classes.table} aria-label="simple table">
                <TableHead style={{zIndex: '98'}}>
                  <TableRow>
                  <TableCell className="checkBoxRowHeading">
                    <div style={{  minWidth: '50px', minHeight: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', background : '#fff'}}>
                      {loader ? <div className="loader-month loader-day"></div> : <input id="allSelectChecBox" type="checkbox" style={{ marginTop: '13px' }} checked={selectAllCheckBox} onChange={handleAllCheckBoxSelected} />}
                    </div>
                  </TableCell>
                  <ColumnResizer className={classes.columnResizer} style={{ border: 'none' }} />

                    <TableCell align="center" className="Sr" style={{ minWidth: '50px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Sr."}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="TaskName" style={{ minWidth: '400px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>
                      {loader ? <div className="loader-month loader-day"></div> : <div onClick={handleSortByName} style={{ cursor: "pointer" }}>Task Name</div>}
                      <div className="asecending-decending" onClick={handleSortByName}>
                        {
                          sortBy === 'name' && isAssendingName ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : (sortBy === 'name' && !isAssendingName ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : null)
                        }
                      </div>
                    </TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Assignee" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="row-time-cell">
                    <div style={{ minWidth: '50%', maxWidth: '50%' }} onClick={handleSortByAssignedto} className="day-status-column-header">Assigned to<div className="asecending-decending" onClick={handleSortByAssignedto}>
                      {
                        sortBy === 'assigned' && isAssendingAssignedto ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : (sortBy === 'assigned' && !isAssendingAssignedto ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : null)
                      }
                    </div></div>
                    {/* <div style={{ minWidth: '50%', maxWidth: '50%' }}>End Time</div> */}
                  </div>}</TableCell>
                  <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Status" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="day-status-column-header" onClick={handleSortByStatus}>Status <div className="asecending-decending" onClick={handleSortByStatus}>
                      {
                        sortBy === 'status' && isAssendingStatus ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : (sortBy === 'status' && !isAssendingStatus ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : null)
                      }
                    </div></div>}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Project" style={{ minWidth: '170px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="row-time-cell">
                      <div style={{ minWidth: '50%', maxWidth: '50%' }} onClick={handleSortByTime} className="day-status-column-header">Time<div className="asecending-decending" onClick={handleSortByTime}>
                        {
                          sortBy === 'time' && isAssendingTime ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : (sortBy === 'time' && !isAssendingTime ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : null)
                        }
                      </div></div>
                      {/* <div style={{ minWidth: '50%', maxWidth: '50%' }}>End Time</div> */}
                    </div>}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />



                    <TableCell align="center" className="Due" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="row-time-cell">
                      <div style={{ minWidth: '50%', maxWidth: '50%' }}><div className="day-status-column-header" onClick={handleSortByStartDate}>Start Date <div className="asecending-decending" onClick={handleSortByStartDate}>
                        {
                          sortBy === 'startdate' && isAssendingStartDate ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : (sortBy === 'startdate' && !isAssendingStartDate ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : null)
                        }
                      </div></div></div>
                      <div style={{ minWidth: '50%', maxWidth: '50%', boxSizing: 'border-box', paddingLeft: '10px', display: 'flex' }}><div className="day-status-column-header" onClick={handleSortByDueDate}>Due Date <div className="asecending-decending" onClick={handleSortByDueDate}>
                        {
                          sortBy === 'duedate' && isAssendingDueDate ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : (sortBy === 'duedate' && !isAssendingDueDate ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : null)
                        }
                      </div></div></div>
                    </div>}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />


                    <TableCell align="center" className="Assignee" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="row-time-cell">
                      <div style={{ minWidth: '50%', maxWidth: '50%' }} onClick={handleSortByAssigned} className="day-status-column-header">Assigned by<div className="asecending-decending" onClick={handleSortByAssigned}>
                        {
                          sortBy === 'assigned' && isAssendingAssigned ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : (sortBy === 'assigned' && !isAssendingAssigned ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> : null)
                        }
                      </div></div>
                      {/* <div style={{ minWidth: '50%', maxWidth: '50%' }}>End Time</div> */}
                    </div>}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Verified" style={{ minWidth: '100px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Verified"}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Git" style={{ minWidth: '140px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Git"}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Git" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'left', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Comments"}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />


                    <TableCell align="center" className="Git" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'left', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Approved by"}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Priority" style={{ minWidth: '80px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="day-status-column-header" onClick={handleSortByPriority}>Priority <div className="asecending-decending" onClick={handleSortByPriority}>
                      {
                        sortBy === 'priority' && isAssendingPriority ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : (sortBy === 'priority' && !isAssendingPriority ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : null)
                      }
                    </div></div>}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />


                    <TableCell align="center" className="Assignee" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="row-time-cell">
                    <div style={{ minWidth: '50%', maxWidth: '50%' }} onClick={handleSortByDepartment} className="day-status-column-header">Departments<div className="asecending-decending" onClick={handleSortByDepartment}>
                      {
                        sortBy === 'department' && isAssendingDepartment ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : (sortBy === 'department' && !isAssendingDepartment ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : null)
                      }
                    </div></div>
                    {/* <div style={{ minWidth: '50%', maxWidth: '50%' }}>End Time</div> */}
                  </div>}</TableCell>
                  <ColumnResizer className={classes.columnResizer} />


                    <TableCell align="center" className="Project" style={{ minWidth: '70px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : <div className="day-status-column-header" onClick={handleSortByProject}>Project <div className="asecending-decending" onClick={handleSortByProject}>
                      {
                        sortBy === 'project' && isAssendingProject ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 5.25L3.25 7.5M3.25 7.5L1 5.25M3.25 7.5V0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : (sortBy === 'project' && !isAssendingProject ? <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 2.75L2.75 0.5M2.75 0.5L5 2.75M2.75 0.5V7.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : null)
                      }
                    </div></div>}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />



                    {/* <TableCell align="center" className="Assignee" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Milestone"}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />
  
                        
                    <TableCell align="center" className="Assignee" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Phase"}</TableCell>
                    <ColumnResizer className={classes.columnResizer} />

                    <TableCell align="center" className="Assignee" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'rgba(38, 50, 56, 0.6)' }}>{loader ? <div className="loader-month loader-day"></div> : "Sprint"}</TableCell>
                    <ColumnResizer className={classes.columnResizer} /> */}




                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? dummyTasks.map((task) => <TableRow>
                    <TableCell component="th" scope="row" className="RowHeading">
                      <div style={{ minWidth: '50px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div style={{ minWidth: '50px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', textAlign: 'left', paddingLeft: '3px' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData" key={''} style={{ position: 'relative' }} >
                      <div className="selectDiv selectStatusDivWrapper" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectPriorityDiv" style={{ minWidth: '85px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData projectId">
                      <div className="selectDiv selectProjectDiv" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">

                      <div style={{ minWidth: '120px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectTagDiv" style={{ minWidth: '100px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="assignee_InfoContainer selectedAssigneeDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="assignee_InfoContainer selectedAssigneeDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="assignee_InfoContainer selectedAssigneeDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="assignee_InfoContainer selectedAssigneeDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="assignee_InfoContainer selectedAssigneeDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selsectVerifiedDiv" style={{ minWidth: '120px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectGitDiv" style={{ minWidth: '100px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectGitDiv" style={{ minWidth: '100px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>


                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectGitDiv" style={{ minWidth: '100px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>

                    <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectCommentDiv" style={{ maxWidth: '130px', minHeight: '30px', textAlign: 'left', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingLeft: '14px' }}>
                        <div className="loader-month loader-day"></div>
                      </div>
                    </TableCell>
                  </TableRow>)
                    : null}

                  {!loader && allTask && allTask.length > 0 && allTask.map((taskObj, index) => (
                    <TableRow draggable onDragStart={(e) => handleDragStart(e, index)} onDrop={(e) => handleDrop(e, index)} onDragOver={(e) => e.preventDefault()} onMouseEnter={() => {
                      if (taskObj.request.taskDelete === true || taskObj.request.taskSchedule === true || taskObj.taskTransfer === true) {
                        setReqtOptRow(true)
                        setTaskIdForOption(taskObj.taskId);
                        if (taskObj.request.taskDelete === true) {
                          setRowRqtMsg("delete request for task send sucessfully")
                        } else if (taskObj.request.taskSchedule === true) {
                          setRowRqtMsg("shift request for task send sucessfully")
                        } else if (taskObj.taskTransfer === true) {
                          setRowRqtMsg("transfer request for task send sucessfully")
                        }
                      } else {
                        setRowRqtMsg(null)
                      }
                    }}
                      onMouseLeave={() => {
                        setReqtOptRow(false)
                      }}
                      onClick={() => {
                        handleAddTaskForEmp(index)
                      }} key={index} className={taskOfListPut.includes(taskObj.taskId) ? 'selected-row' : ''}
                      id={((new Date(taskObj.taskDueDate) < new Date(todayDate)) && (taskObj.statusEntity.statusId !== 5 && taskObj.statusEntity.statusId !== 6 ))
                      ? 'selected-row'
                      : ''
                      }
                      style={{ backgroundColor: taskObj.request?.taskDelete === true || taskObj.request?.taskSchedule === true || taskObj.request?.taskTransfer === true ? 'rgb(201, 200, 200, 0.5)' : null, position: 'relative' }}>
                      <TableCell component="th" scope="row" className="RowHeading checkbox" tyle={{position: "sticky", zIndex: '97'}}>
                        <div key={taskObj.taskId} style={{ minWidth: '50px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'sticky'}} onMouseEnter={() => { }} onMouseLeave={() => { }}>
                          <input
                            type="checkbox"
                            id={`checkbox-${taskObj.taskId}`}
                            checked={
                              taskOfListPut.includes(taskObj.taskId)

                            }
                            onChange={
                              self.role[0].role === "ROLE_SUPERADMIN" ||
                                self.role[0].role === "ROLE_ADMIN" ||
                                editeKey === true ||
                                (empInfo.empId.toString() === self.empId.toString()) ||
                                (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                                ? () => handleTaskCheckBox(taskObj.taskId, taskObj) : null}
                          />
                        </div>
                      </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div style={{ minWidth: '50px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          {index + 1}
                        </div>
                      </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div className="taskTileDivContainer" title={taskObj.taskTitle} style={{ minWidth: '400px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', textAlign: 'left', paddingLeft: '3px' }}
                          onMouseEnter={() => {
                            setTaskIdOpenBtn(taskObj.taskId)
                            setTaskOenbtn(true)
                          }}
                          onMouseLeave={() => {
                            setTaskOenbtn(false)
                          }}
                        >
                          {/* onBlur={(e) => handleBlur(e, taskObj, index)} */}
                          <input autoFocus={taskObj.taskTitle === null ? true : false} className="taskTitle"
                            // style={{ backgroundColor: taskObj.request?.taskTitle === true ? '#6f6b6b33' : null, color: (taskObj.statusEntity?.statusId !== 5 && taskObj.statusEntity?.statusId !== 6) && isDateLessThanCurrentforDue(taskObj.taskDueDate) ? 'red' : null }} 
                            // id={
                            // ((new Date(taskObj.taskDueDate).setHours(0, 0, 0, 0) < new Date(fullDateForDue).setHours(0, 0, 0, 0))) &&
                            // ((new Date(taskObj.taskDueDate).setHours(0, 0, 0, 0)) !== (new Date(fullDateForDue).setHours(0, 0, 0, 0)))
                            // ? 'due-task-title'
                            // : ''
                            // } 
                            type="text" value={taskObj.taskTitle} onChange={(e) => {
                              setTaskOenbtn(false)
                              handleTaskChange(e, index, taskObj)
                              setTempTaskTitle(e.target.value)
                            }}
                            onKeyDown={(e) => handleBlur(e, taskObj, index)}
                            {...(taskObj.taskTitle === null && { autoFocus: taskObj.taskTitle === null ? true : false })} disabled={(
                              self.role[0].role === "ROLE_SUPERADMIN" ||
                              self.role[0].role === "ROLE_ADMIN" ||
                              editeKey === true ||
                              (empInfo.empId.toString() === self.empId.toString()) ||
                              (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                            ) ? false : true}></input>

                          {taskOpenBtn && taskOpenId === taskObj.taskId && taskObj.taskId !== null &&
                            <div className="taskDetails" onClick={() => {
                              dispatch(setTaskDetailObj(taskObj))
                              dispatch(setTaskDetailFlag(true))
                            }}>
                              <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '15px', width: '15px' }}>
                                <path d="M3.625 1H1.875C1.64294 1 1.42038 1.09219 1.25628 1.25628C1.09219 1.42038 1 1.64294 1 1.875V7.125C1 7.35706 1.09219 7.57962 1.25628 7.74372C1.42038 7.90781 1.64294 8 1.875 8H7.125C7.35706 8 7.57962 7.90781 7.74372 7.74372C7.90781 7.57962 8 7.35706 8 7.125V5.375M4.5 4.5L8 1M8 1V3.1875M8 1H5.8125" stroke="#263238" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              <p>OPEN</p>
                            </div>
                          }

                          {taskIdOption === taskObj?.taskId && reqtOptRow &&
                            <div className="taskRowRqtHoverDiv">{`request send for ${taskObj.request.taskDelete === true ? 'delete' : ''}${taskObj.request.taskSchedule === true ? ',shift ' : ''}${taskObj.request.taskTransfer === true ? ',transfer' : ''}`}</div>
                          }
                        </div>
                      </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div className="assignee_InfoContainer selectedAssigneeDiv selectMileStoneDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }}
                        // onClick={(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") ? () => {
                        //   axios.post(`${apiUrl}employee/get/task-owners`, { 'roleLevel': empInfo.role[0].roleLevel }, { headers: storedHeaders })
                        //     .then(response => {
                        //       if (response.request.status === 200) {
                        //         setAssigness(response.data)
                        //       }
                        //     })
                        //     .catch(error => {
                        //     })

                        //   setTaskIdForOption(taskObj.taskId)
                        //   setAssigneeOption(true)
                        // } : null}
                        >
                          <div className="taskOwnerImage"><img id="taskOwnerImage" src={taskObj.taskEmployee?.empImg ? taskObj.taskEmployee?.empImg : profile} alt="" /></div>
                          <div className="AssigneeName"><p>{taskObj.taskEmployee?.empFullName}</p></div>

                          {/* {assigneeOption && taskIdOption === taskObj.taskId &&
                            <div className="listOfAsssigneeWrapper" style={{ zIndex: 1000 }} ref={assigneeRef}>
                              <div className="listOfAsssigneeWrapperScroller">
                                {assigness && assigness.length > 0 && assigness.map((emplObj) => (
                                  <div className="AssigneDiv-name-img" onClick={() => {
                                    // UPDATE(6, index, taskObj, emplObj)
                                  }}>
                                    <div className="taskOwnerImage"><img id="taskOwnerImage" src={emplObj.empImg ? emplObj.empImg : profile} alt="" /></div>
                                    <div className="AssigneeName"><p>{emplObj?.empFullName}</p></div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          } */}

                        </div>
                      </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData" key={''} style={{ position: 'relative' }} >
                        {(self.role[0].role !== "ROLE_SUPERADMIN" && self.role[0].role !== "ROLE_ADMIN") && taskObj.taskOwner.empId === self.empId && taskObj.taskView.length === 0 && route !== 'level' &&
                          <div className="ViewAcessDiv"></div>
                        }

                        {(self.role[0].role !== "ROLE_SUPERADMIN" && self.role[0].role !== "ROLE_ADMIN") && taskObj.taskOwner.empId === self.empId && taskObj.taskView.length === 0 && route !== 'mytask' &&
                          <div className="ViewAcessDiv"></div>
                        }

                        <div className="selectDiv selectStatusDivWrapper" style={{ minWidth: '150px', minHeight: '30px', textAlign: 'center' }} onClick={
                          ((
                            self.role[0].role === "ROLE_SUPERADMIN" ||
                            self.role[0].role === "ROLE_ADMIN" ||
                            editeKey === true ||
                            (empInfo.empId.toString() === self.empId.toString()) ||
                            (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                          ) && ((self?.role[0]?.role === "ROLE_SUPERADMIN" || self?.role[0]?.role === "ROLE_ADMIN") || (((taskObj?.taskEmployee && ((selfInfoEmp?.empId === taskObj?.taskEmployee?.empId) && (taskObj?.taskView?.length > 0)))) || (selfInfoEmp?.empId !== self?.empId)))) ? (event) => {
                            if (formattedDateString < formattedDateComp && (parseInt(taskObj.statusEntity.statusId) !== 5 && parseInt(taskObj.statusEntity.statusId) !== 6)) {
                              setTaskIdForOption();
                              setStatusOption(false);
                              handleCheckHeight(event)
                            } else {
                              setTaskIdForOption(taskObj.taskId);
                              setStatusOption(true);
                              handleCheckHeight(event)
                              setStatuses(dStatuses?.filter(obj => obj?.statusId !== taskObj?.statusEntity?.statusId))
                            }
                          } : null}
                          onMouseEnter={() => {
                            setreqtMsgFlagStatus(true)
                            setTaskReqtIdOpt(taskObj.taskId)
                          }}

                          onMouseLeave={() => {
                            setreqtMsgFlagStatus(false)

                          }}
                        >
                          <div className="OutputWrapperProrityForRqt"  >
                            <div className="OutputWrapperStatus" style={{ backgroundColor: taskObj.statusEntity?.statusColorCode }}>
                              {taskObj.request?.statusEntity === true ?
                                <div className="requestedBox"></div> : null
                              }
                              {/* <div className="statusDot" style={{backgroundColor : taskObj.statusEntity?.statusColorCode, width: '6px', height: '6px', borderRadius: '50px'}}></div> */}
                              {taskObj.statusEntity ? taskObj.statusEntity.status : null}
                            </div>
                          </div>

                          {(self.role[0].role !== "ROLE_SUPERADMIN" || self.role[0].role !== "ROLE_ADMIN") && (
                            statusOption && taskIdOption === taskObj.taskId && (
                              <div className="listOfStatusWrapper" style={{ zIndex: 99, top: checkHeight > 470 ? '-134': '31px' }} ref={statusListRef}>
                                {statuses && statuses.length > 0 && statuses.map((statusObj) => (
                                  (statusObj.statusId !== 6) && (
                                    <div style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                      if (clicked) {
                                        return
                                      }
                                      setClicked(true)
                                      UPDATE(1, index, taskObj, statusObj)
                                    }}>
                                      {statusObj.status}
                                    </div>
                                  )
                                ))}
                              </div>
                            )
                          )}

                          {(self.role[0].role === "ROLE_SUPERADMIN") && (
                            statusOption && taskIdOption === taskObj.taskId && (
                              <div className="listOfStatusWrapper" style={{ zIndex: 99, top: checkHeight > 470 ? '-134': '31px' }} ref={statusListRef}>
                                {statuses && statuses.length > 0 && statuses.map((statusObj) => (
                                  <div style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                    if (clicked) {
                                      return
                                    }
                                    setClicked(true)
                                    UPDATE(1, index, taskObj, statusObj)
                                  }}>
                                    {statusObj.status}
                                  </div>
                                ))}
                              </div>
                            )
                          )}

                          {(self.role[0].role === "ROLE_ADMIN") && (
                            (route === 'mytask' || route === 'level' && selfInfoEmp.empId === self.empId) ? (
                              statusOption && taskIdOption === taskObj.taskId && (
                                taskObj.taskOwner.empId.toString() !== self.empId.toString() ? (
                                  <div className="listOfStatusWrapper" style={{ zIndex: 99, top: checkHeight > 470 ? '-134': '31px' }} ref={statusListRef}>
                                    {statuses && statuses.length > 0 && statuses.map((statusObj) => (
                                      (statusObj.statusId !== 6) && (
                                        <div style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                          if (clicked) {
                                            return
                                          }
                                          setClicked(true)
                                          UPDATE(1, index, taskObj, statusObj)
                                        }}>
                                          {statusObj.status}
                                        </div>
                                      )
                                    ))}
                                  </div>
                                ) : (
                                  statusOption && taskIdOption === taskObj.taskId && (
                                    <div className="listOfStatusWrapper" style={{ zIndex: 99, top: checkHeight > 470 ? '-134': '31px' }} ref={statusListRef}>
                                      {statuses && statuses.length > 0 && statuses.map((statusObj) => (
                                        <div style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                          if (!clicked) {
                                            setClicked(true);
                                            UPDATE(1, index, taskObj, statusObj);
                                          }
                                        }} key={statusObj.statusId}>
                                          {statusObj.status}
                                        </div>
                                      ))}
                                    </div>
                                  )
                                )
                              )
                            ) : (
                              statusOption && taskIdOption === taskObj.taskId && (
                                <div className="listOfStatusWrapper" style={{ zIndex: 99, top: checkHeight > 470 ? '-134': '31px' }} ref={statusListRef}>
                                  {statuses && statuses.length > 0 && statuses.map((statusObj) => (
                                    <div key={statusObj.statusId} style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                      if (!clicked) {
                                        setClicked(true);
                                        UPDATE(1, index, taskObj, statusObj);
                                      }
                                    }}>
                                      {statusObj.status}
                                    </div>
                                  ))}
                                </div>
                              )
                            )
                          )}

                          {statusOption && taskIdOption === taskObj.taskId &&
                            <div className="triangleDivForList"></div>
                          }
                        </div>
                      </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData projectId">
                      <div className="selectDiv selectProjectDiv" style={{ minWidth: '190px', minHeight: '30px', textAlign: 'center' }}>
                        <div className="OutputWrapperTime" >
                          <div className="startTime-picker" onClick={(
                            self.role[0].role === "ROLE_SUPERADMIN" ||
                            self.role[0].role === "ROLE_ADMIN" ||
                            editeKey === true ||
                            (empInfo.empId.toString() === self.empId.toString()) ||
                            (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                          ) ? () => {
                            setStartTimeFlag(true)
                            setTaskIdForOption(taskObj.taskId)
                          } : null}>
                            <div className="absoluetStartTime " ref={strtTimeRef} >
                              <div>
                                <Space wrap>
                                  <TimePicker className='tempTimePicker' placeholder={taskObj?.taskTimeFrom !== null ? `${convertTimeFormat(taskObj?.taskTimeFrom)}` : 'Start'} use24Hours minuteStep={1} secondStep={1} hourStep={1} format={'h:mm a'} onClick={() => setTempIndex(index)} onChange={
                                    (self.role[0].role === "ROLE_SUPERADMIN" ||
                                      self.role[0].role === "ROLE_ADMIN" ||
                                      editeKey === true ||
                                      (empInfo.empId.toString() === self.empId.toString()) ||
                                      (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())) ? handleStartTime : null} />
                                </Space>
                              </div>
                            </div>
                          </div>

                          <div className="timeSepeartor">-</div>
                          <div className="startTime-picker" onClick={(
                            self.role[0].role === "ROLE_SUPERADMIN" ||
                            self.role[0].role === "ROLE_ADMIN" ||
                            editeKey === true ||
                            (empInfo.empId.toString() === self.empId.toString()) ||
                            (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                          ) ? () => {
                            setEndTimeFlag(true)
                            setTaskIdForOption(taskObj.taskId)
                          } : null}>

                            <div className="absoluetStartTime" ref={endTimeRef} >
                              {/* <input type="time" min={taskObj.taskTimeFrom} value={taskObj.taskTimeTo} step='900'
                                onChange={(
                                  self.role[0].role === "ROLE_SUPERADMIN" ||
                                  self.role[0].role === "ROLE_ADMIN" ||
                                  editeKey === true ||
                                  (empInfo.empId.toString() === self.empId.toString()) ||
                                  (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())

                                ) ? (e) => setEndTime(e.target.value) : null}
                                onBlur={(e) => {
                                  UPDATE(10, index, taskObj, endTime);
                                }} disabled={!taskObj.taskTimeFrom ? true : false} /> */}
                              <div>
                                <Space wrap>
                                  <TimePicker className='tempTimePicker' placeholder={taskObj?.taskTimeTo !== null ? `${convertTimeFormat(taskObj?.taskTimeTo)}` : 'End'} use24Hours minuteStep={1} secondStep={1} hourStep={1} format={'h:mm a'} onClick={() => setTempIndex(index)} onChange={
                                    (self.role[0].role === "ROLE_SUPERADMIN" ||
                                      self.role[0].role === "ROLE_ADMIN" ||
                                      editeKey === true ||
                                      (empInfo.empId.toString() === self.empId.toString()) ||
                                      (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())) ? handleEndTime : null} />
                                </Space>
                              </div>
                            </div>
                          </div>
                          <div>
                          </div>
                        </div>
                      </div>
                    </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData" style={{ position: 'relative' }}>
                        <div style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                          <div classNam="taskScheduleDiv" onMouseEnter={() => {
                            setdueTipIdFlag(taskObj.taskId)
                            setMsgShdtTip(true)
                          }} onMouseLeave={() => {
                            setMsgShdtTip(false)
                          }} >
                            {taskObj.taskSchedule}
                          </div>

                          <p className="dash-schedule">-</p>
                          <div className="outputDueDateWrapper"
                            style={{ backgroundColor: taskObj.request?.taskDueDate === true ? 'rgb(201, 200, 200, 0.6)' : null }}
                            onClick={(
                              self.role[0].role === "ROLE_SUPERADMIN" ||
                              self.role[0].role === "ROLE_ADMIN" ||
                              editeKey === true ||
                              (empInfo.empId.toString() === self.empId.toString()) ||
                              (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                            ) ? () => {
                              setTaskIdForOption(taskObj.taskId)
                              setDueDateOption(true)
                              setDueDatePut(taskObj.taskDueDate)
                              var dateInput = document.getElementById('dateInput');
                              setIsVisible(true);
                            } : null} onMouseEnter={() => {
                              setMsgDueTip(true);
                              setdueTipIdFlag(taskObj.taskId)
                            }}
                            onMouseLeave={() => {
                              setMsgDueTip(false);
                              setdueTipIdFlag(taskObj.taskId)
                            }}>
                            {taskObj.taskDueDate}</div>

                          {taskIdOption === taskObj.taskId && dueDateOption &&
                            <div className="dueDateCalenderWrapper" ref={dueDateRef}>
                              {/* <input type="date" value={dueDateput} placeholder=" " id="DueDatePicker" className="DueDatePicker" autoFocus={true} min={new Date().toISOString().split('T')[0]} onChange={(e) => {
                                setDueDatePut(e.target.value)
                                UPDATE(4, index, taskObj, e.currentTarget.value)
                              }}
                              /> */}
                              <div className='calender-holder-dashboard'>

                                <Calendar value={new Date(taskObj.taskDueDate)} inline onChange={(e) => {
                                  if (clicked) {
                                    return
                                  }
                                  setClicked(true)
                                  const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                                  setDueDatePut(formattedDate)
                                  UPDATE(4, index, taskObj, formattedDate)
                                  setRouteDateShiftSingle("")
                                }} unstyled={false} minDate={new Date(taskObj.taskSchedule)} />
                              </div>
                            </div>
                          }
                          {/* {tooltipDue && dueTipIdFlag === taskObj.taskId && 
                            <div className="tooltipDue">
                              {"reuest all ready sent"}
                            </div>
                          } */}
                        </div>
                      </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div className="assignee_InfoContainer selectedAssigneeDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }} onClick={(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") ? () => {
                          axios.post(`${apiUrl}employee/get/task-owners`, { 'roleLevel': empInfo?.role[0].roleLevel }, { headers: storedHeaders })
                            .then(response => {
                              if (response.request.status === 200) {
                                setAssigness(response.data)
                              }
                            })
                            .catch(error => {
                            })

                          setTaskIdForOption(taskObj.taskId)
                          setAssigneeOption(true)
                        } : null}>
                          <div className="taskOwnerImage"><img id="taskOwnerImage" src={taskObj.taskOwner.empImg ? taskObj.taskOwner.empImg : profile} alt="" /></div>
                          <div className="AssigneeName"><p>{taskObj?.taskOwner?.empFullName}</p></div>

                          {assigneeOption && taskIdOption === taskObj.taskId &&
                            <div className="listOfAsssigneeWrapper" style={{ zIndex: 1000 }} ref={assigneeRef}>
                              <div className="listOfAsssigneeWrapperScroller">
                                {assigness && assigness?.length > 0 && assigness?.map((emplObj) => (
                                  <div className="AssigneDiv-name-img" onClick={() => {
                                    UPDATE(6, index, taskObj, emplObj)
                                  }}>
                                    <div className="taskOwnerImage"><img id="taskOwnerImage" src={emplObj.empImg ? emplObj.empImg : profile} alt="" /></div>
                                    <div className="AssigneeName"><p>{emplObj?.empFullName}</p></div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          }
                          {assigneeOption && taskIdOption === taskObj.taskId &&
                            <div className="triangleDivForList triangleDivForAssigneeList "></div>
                          }
                        </div>
                      </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div className="selectDiv selsectVerifiedDiv" style={{ minWidth: '120px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div className="OutputWrapperVerified" onClick={
                            ((self.department.departmentName === "QA" || self.department.departmentName === 'Testing') && (taskObj.taskGitLink !== null || self.empId.toString() !== taskObj.taskOwner.empId.toString())) ||
                              self.role[0].role === "ROLE_SUPERADMIN" ||
                              self.role[0].role === "ROLE_ADMIN"
                              ? () => {
                                setTaskIdForOption(taskObj.taskId);
                                setverifiedOption(true);
                                setVerifies(dVerifieds?.filter(obj => obj?.verificationStatusId !== taskObj?.task_verified?.verificationStatusId))
                              }
                              : null} style={{ backgroundColor: taskObj?.task_verified ? taskObj?.task_verified.verificationColorCode : null }}>{taskObj.task_verified?.verificationStatus}</div>

                          {taskIdOption === taskObj.taskId && verfiedOption &&
                            <div className="listOfVerifiedWrapper" style={{ zIndex: 1000 }} ref={verifiedListRef}>
                              {verifieses && verifieses.length > 0 && verifieses.map((verifiedObj) => (
                                <div style={{ backgroundColor: verifiedObj ? verifiedObj?.verificationColorCode : null }} onClick={() => {
                                  setVerifies(dVerifieds?.filter(obj => obj?.verificationStatusId !== verifiedObj?.verificationStatusId))
                                  UPDATE(7, index, taskObj, verifiedObj, null)}}>{verifiedObj.verificationStatus}</div>
                              ))}
                            </div>
                          }
                          {taskIdOption === taskObj.taskId && verfiedOption &&
                            <div className="triangleDivForList"></div>
                          }
                        </div>
                      </TableCell>


                      <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectGitDiv" style={{ minWidth: '100px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        {/* {taskIdOption === taskObj.taskId && gitLinkInputBox &&
                          <div className="gitLinkInput" ref={gitRef}>
                            <input type="text" id="gitInputBox" value={gitLinkValue} placeholder="Enter git Link..." onChange={handleGitInputChange} onKeyDown={(e) => handleGitKeyDown(e, 8, index, taskObj, e.target.value)} />
                            <input type="checkbox" id={`checkboxFlag-${taskObj.taskId}`} checked={taskObj.taskId === testerTaskId && testerFlag} onChange={() => {
                              setTesterFlag(!testerFlag)
                              setTesterTaskId(taskObj.taskId)
                            }} /> 
                          </div>
                          
                        } */}

                        <div className="OutputWrapperGit" style={{ backgroundColor: taskObj.taskGitLink !== null ? 'rgba(1, 159, 55, 0.15)' : null }}>
                          <li style={{ listStyle: 'none' }} >
                            <a href={taskObj.taskGitLink} target="_blank" rel="noreferrer">{taskObj.taskGitLink === null ? "-" : "Pushed"}</a>
                          </li>
                        </div>



                        {
                          taskObj.taskGitLink === null ?
                            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '12px', height: '15px', cursor: 'pointer' }} onClick={(
                              self.role[0].role === "ROLE_SUPERADMIN" ||
                              self.role[0].role === "ROLE_ADMIN" ||
                              editeKey === true ||
                              (empInfo.empId.toString() === self.empId.toString()) ||
                              (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                            ) ? () => {
                              if (taskObj.projectEntity !== null) {
                                setGitTaskObj(taskObj)
                                setGitLinkValue(taskObj.taskGitLink)
                                settaskToTestpopup(true)
                              } else {
                                setTaskIdForOption(taskObj.taskId)
                                setGitMsgForNotPrj(true)
                              }

                            } : null}>
                              <path opacity="0.6" fill-rule="evenodd" clip-rule="evenodd" d="M3.5 0C3.77614 0 4 0.159898 4 0.357142V3H6.64286C6.8401 3 7 3.22386 7 3.5C7 3.77614 6.8401 4 6.64286 4H4V6.64286C4 6.8401 3.77614 7 3.5 7C3.22386 7 3 6.8401 3 6.64286V4H0.357142C0.159898 4 0 3.77614 0 3.5C0 3.22386 0.159898 3 0.357142 3H3V0.357142C3 0.159898 3.22386 0 3.5 0Z" fill="black" />
                            </svg>

                            :
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" id="editeGitLink" style={{ width: '15px', height: '15px' }} onClick={(
                              self.role[0].role === "ROLE_SUPERADMIN" ||
                              self.role[0].role === "ROLE_ADMIN" ||
                              editeKey === true ||
                              (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                            ) ? () => {
                              if (taskObj.projectEntity !== null) {
                                setTaskIdForOption(taskObj.taskId)
                                setGitTaskId(taskObj.task)
                                setGitTaskObj(taskObj)
                                settaskToTestpopup(true)
                                setGitLinkValue(taskObj.taskGitLink)

                              } else {
                                setTaskIdForOption(taskObj.taskId)
                                setGitMsgForNotPrj(true)
                              }
                            }
                              : null}>
                              <path d="M1.99805 8.60343V9.74992C1.99805 9.81623 2.02439 9.87982 2.07127 9.9267C2.11815 9.97359 2.18174 9.99992 2.24805 9.99992H3.39705C3.46322 9.99991 3.52669 9.97366 3.57355 9.92692L8.29755 5.20292L6.79755 3.70292L2.07155 8.42692C2.02463 8.4737 1.99819 8.53718 1.99805 8.60343ZM7.41655 3.08342L8.91655 4.58342L9.64655 3.85342C9.74028 3.75966 9.79294 3.63251 9.79294 3.49992C9.79294 3.36734 9.74028 3.24019 9.64655 3.14642L8.85405 2.35342C8.76028 2.25969 8.63313 2.20703 8.50055 2.20703C8.36796 2.20703 8.24081 2.25969 8.14705 2.35342L7.41655 3.08342Z" fill="black" />
                            </svg>
                        }

                        {gitMsgForNoPrj && taskIdOption === taskObj.taskId &&
                          <div className="gitmsgforProject" ref={gitMsgRef}>
                            please assign a project to this task
                          </div>
                        }
                      </div>
                    </TableCell>


                      <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectCommentDiv" style={{ maxWidth: '130px', minHeight: '30px', textAlign: 'left', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingLeft: '14px', position: 'relative' }} onMouseEnter={
                        taskObj.taskComment !== null ? () => {
                          setTaskIdForOption(taskObj.taskId)
                          setCmtOption(true)
                        } : null}
                        onMouseLeave={() => { setCmtOption(false) }}
                      >
                        <input style={{ cursor: 'pointer' }} className="taskTitle" id="taskTitle-input" type="text" value={taskObj.taskComment ? extractPlainText(removeStringParse(taskObj?.taskComment)) : ''} onClick={() => {
                          if (taskObj.taskId !== null) {
                            dispatch(setIsCommentView(true))
                            dispatch(setTaskDetailObj(taskObj))
                            dispatch(setTaskDetailFlag(true))
                          } else {
                            toast.error("Please add the task first", { toastId: 'success', autoClose: 2000 });
                          }
                        }}
                          // onChange={(e) => handleCommentsChange(e, index)}
                          // onBlur={(e) => handleCommentsEdit(e, index, taskObj)} {...(taskObj.taskComment === '' && { autoFocus: false })} 
                          disabled={(
                            self.role[0].role === "ROLE_SUPERADMIN" ||
                            self.role[0].role === "ROLE_ADMIN" ||
                            editeKey === true ||
                            (empInfo.empId.toString() === self.empId.toString()) ||
                            (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                          ) ? false : true}></input>

                        {taskIdOption === taskObj.taskId && cmtOption && (taskObj.taskComment !== null || taskObj.taskComment !== '') &&
                          <div className="taskCmtHoverDiv">
                            <div>
                              {taskObj.taskComment ? extractPlainText(removeStringParse(taskObj.taskComment)) : ''}</div>
                          </div>
                        }

                      </div>
                    </TableCell>
                      <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectDiv selectCommentDiv viewEmp" style={{
                        maxWidth: '100%', minHeight: '30px', textAlign: 'left', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', position: 'relative', cursor: 'pointer'
                      }} onMouseEnter={() => {
                        setTaskIdViewOPt(taskObj.taskId)
                        setViewdListFlg(true)
                      }}
                        onMouseLeave={() => {
                          setViewdListFlg(false)
                        }}>
                        {
                          (self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") && (
                            <div className='view-eye'>
                              {!isView(taskObj) === false && (
                                <div className="approve-task" onClick={(e) => {
                                    setViewTaskId(taskObj.taskId)
                                    handleViewEmpSingle(taskObj, index)
                                }}>Approve</div>
                              )}

                              <div className="approvedStatusDiv">
                                {self.role[0].roleLevel ? (
                                  taskObj && taskObj.taskView?.length > 0 && taskObj.taskView?.map((obj, index) => (
                                    <div key={index} style={{ position: 'absolute', left: `${20 * index}px`, background: '#fff' }} className="taskOwnerImage viewedByDiv">
                                      <img id="taskOwnerImage" src={obj ? obj.empImg : profile} alt="" />
                                    </div>
                                  ))
                                ) : (
                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100px', height: '100%' }}>
                                    <div className="approve-task" style={{ background: "#ff0000ad" }}>Not Approved</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )
                        }

                        {(self.role[0].role !== "ROLE_SUPERADMIN" && self.role[0].role !== "ROLE_ADMIN") &&
                          <div className='view-eye'>
                            {taskObj.taskView.length > 0 ? (
                              taskObj.taskView.map((obj, index) => (
                                <div key={index} style={{ position: 'absolute', left: `${20 * index}px`, background: '#fff' }} className="taskOwnerImage viewedByDiv">
                                  <img id="taskOwnerImage" src={obj ? obj.empImg : profile} alt="" />
                                </div>
                              ))
                            ) : (
                              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 'max-content', height: '100%' }}>
                                <div className="approve-task" style={{ background: "#ff0000ad" }}>Not Approved</div>
                              </div>
                            )}
                          </div>
                        }

                        {taskIdViewOPt === taskObj.taskId && viewdListFlg && taskObj.taskView.length > 0 &&
                          <div className="viewListContainer">
                            <div className="viewListContainerScroll">
                              {taskObj.taskView?.map((obj, index) => (
                                <div className="ViewEmpInfo" key={index}>
                                  <div className="taskOwnerImage viewedByDiv">
                                    <img id="taskOwnerImage" src={obj ? obj.empImg : profile} alt="" />
                                  </div>
                                  <div>{obj.empFullName}</div>
                                  <div>{obj.viewedTimeStamp}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        }
                      </div>
                    </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData" style={{ position: 'relative' }}>

                        <div className="selectDiv selectPriorityDiv"
                          onMouseEnter={() => {
                            setReqtMsgFlag(true)
                            setTaskReqtIdOpt(taskObj.taskId)
                          }}

                          onMouseLeave={() => {
                            setReqtMsgFlag(false)
                          }}
                          onClick={(
                            self.role[0].role === "ROLE_SUPERADMIN" ||
                            self.role[0].role === "ROLE_ADMIN" ||
                            editeKey === true ||
                            (empInfo.empId.toString() === self.empId.toString()) ||
                            (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())

                          ) ? () => {
                            setTaskIdForOption(taskObj.taskId)
                            setPriorityOption(true)
                            setPriorities(dPriorities?.filter( obj => obj?.priorityId !== taskObj?.priorityEntity?.priorityId))
                          } : null}>
                          <div className="OutputWrapperProrityForRqt" style={{ backgroundColor: taskObj.request?.priorityEntity === true ? null : null }}  >
                            <div className="OutputWrapperPrority" style={{
                              backgroundColor: `${taskObj.priorityEntity?.priorityColorCode}`
                            }}>{taskObj.request?.priorityEntity === true ?
                              <div className="requestedBox"></div> : null
                              }
                              {taskObj.priorityEntity ? taskObj.priorityEntity?.priority : ''}
                            </div>
                          </div>

                          {taskIdOption === taskObj.taskId && prorityOption &&
                            <div className="listOfProrityWrapper" style={{ zIndex: 1000 }} ref={priorityListRef}>
                              {priorities && priorities.length > 0 && priorities.map((priorityObj) => (
                                <div className="listOfProrityWrapper-container">
                                  <div style={{ backgroundColor: `${priorityObj.priorityColorCode}` }} onClick={() => {
                                    if (clicked) {
                                      return
                                    }
                                    setClicked(true)
                                    UPDATE(2, index, taskObj, priorityObj)
                                  }}>{priorityObj.priority}</div>
                                </div>
                              ))}
                            </div>
                          }
                          {taskIdOption === taskObj.taskId && prorityOption &&
                            <div className="triangleDivForList triangleDivForPriorityList"></div>
                          }
                        </div>
                      </TableCell>



                      <TableCell className={classes.columnResizer1}></TableCell>
                    <TableCell align="center" className="coloumnData">
                      <div className="selectTagDiv" style={{ minWidth: '100px', minHeight: '30px', textAlign: 'center', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                        <div className="OutputWrapperTags" onClick={(
                          self.role[0].role === "ROLE_SUPERADMIN" ||
                          self.role[0].role === "ROLE_ADMIN" ||
                          editeKey === true ||
                          (empInfo.empId.toString() === self.empId.toString()) ||
                          (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())

                        ) ? () => {
                          setTaskIdForOption(taskObj.taskId)
                          setTagOption(true)
                          let tempList = dTags;
                          taskObj?.tags?.forEach(tagObj => {
                            tempList = tempList.filter(obj => obj?.departmentId?.toString() !== tagObj?.departmentId?.toString());
                          });
                          setTags(tempList);

                        } : null}>
                          {taskObj.tags && taskObj.tags.length > 0 && taskObj.tags.map((tagObj) => (
                            <div key={tagObj.departmentId} className="OutputTag" style={{ backgroundColor: tagObj ? tagObj.departmentColorCode : null }}>{tagObj.departmentName}</div>
                          ))}
                        </div>

                        {taskIdOption === taskObj.taskId && tagOption &&
                          <div className="listOfTagsWrapper" style={{zIndex: 9999999, top: checkHeight > 470 ? '-290px': '31px', flexDirection: checkHeight > 470 ? 'column-reverse': 'column'}} ref={tagListRef}>
                            <div className="listOfSeletedTags">
                              <div className="listOfSeletedTagsScroller">
                                {taskObj.tags && taskObj.tags .length > 0 && taskObj.tags .map((tagObj) => (
                                  <div key={tagObj.departmentId} className="OutputTagChange" style={{ backgroundColor: tagObj ? tagObj.departmentColorCode : null}} >
                                    <p>{tagObj.departmentName}</p>
                                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                      setTagOption(true)
                                      const tempTags = allTask[index].tags.filter(taskTagObj => taskTagObj.departmentId !== tagObj.departmentId)
                                      allTask[index].tags = tempTags
                                      const tagIdArray = allTask[index].tags.map(tag => tag.departmentId);
                                      setAllTask([...allTask]); 
                                      dispatch(setDispatchAllTask([...allTask]));
                                      let tempList = dTags;
                                      taskObj?.tags?.forEach(tagObj => {
                                        tempList = tempList.filter(obj => obj?.departmentId?.toString() !== tagObj?.departmentId?.toString());
                                      });
                                      setTags(tempList);
                                      axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTags": tagIdArray }, { headers: storedHeaders })
                                      .then(response => {
                                        if (response.request.status === 200) {
                                          toast.success("task Departments Updated successfully", { toastId: 'success', autoClose: 2000 });
                                        }
                                      })
                                      .catch(error => {});
                                      
                                    }}>
                                      <path d="M4.71751 0.525126C4.91278 0.329864 5.22936 0.329864 5.42462 0.525126C5.61988 0.720388 5.61988 1.03697 5.42462 1.23223L1.18198 5.47487C0.986718 5.67014 0.670136 5.67014 0.474874 5.47487C0.279612 5.27961 0.279612 4.96303 0.474874 4.76777L4.71751 0.525126ZM0.474874 0.525126C0.670136 0.329864 0.986718 0.329864 1.18198 0.525126L5.42355 4.7667C5.61882 4.96196 5.61882 5.27854 5.42355 5.47381C5.22829 5.66907 4.91171 5.66907 4.71645 5.47381L0.474874 1.23223C0.279612 1.03697 0.279612 0.720388 0.474874 0.525126Z" fill="#263238" />
                                    </svg>
                                  </div>
                                 ))}
                              </div>
                            </div>
                            {tags && tags.length > 0 && tags.map((tagObj) => (
                              <div key={tagObj.departmentId} style={{ backgroundColor: tagObj.departmentColorCode }} onClick={() => {
                                  if(isTagInList(tagObj, index)){
                                      return
                                  }else{
                                    allTask[index].tags = [
                                      ...allTask[index].tags,
                                      tagObj 
                                    ];
                                    setAllTask([...allTask]); 
                                    dispatch(setDispatchAllTask([...allTask]));
                                    let tempList = dTags;
                                      taskObj?.tags?.forEach(tagObj => {
                                        tempList = tempList.filter(obj => obj?.departmentId?.toString() !== tagObj?.departmentId?.toString());
                                      });
                                      setTags(tempList);
                                    const tagIdArray = allTask[index].tags.map(tag => tag.departmentId);
                                    axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskTags": tagIdArray }, { headers: storedHeaders })
                                    .then(response => {
                                      if (response.request.status === 200) {
                                        toast.success("task Departments Updated successfully", { toastId: 'success', autoClose: 2000 });
                                      }
                                    })
                                    .catch(error => {}); // Changed response to error                                  
                                  }
                              }}>{tagObj.departmentName}</div>
                            ))}
                          </div>
                        }

                        {taskIdOption === taskObj.taskId && tagOption &&
                          <div className="triangleDivForList" style={{borderBottom : checkHeight > 470 ? '0px' : '10px solid rgba(82, 79, 79, 0.5)', borderTop: checkHeight > 470 ? '10px solid rgba(82, 79, 79, 0.5)' : '0px',  top : checkHeight > 470 ? '-3px' : '26px'}}></div>
                        }
                      </div>
                    </TableCell>

                      <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData projectId" style={{ position: 'relative' }}>
                        <div className="selectDiv selectProjectDiv" style={{ minWidth: '70px', minHeight: '30px', textAlign: 'center' }}
                          onMouseEnter={() => {
                            setReqtMsgFlagProject(true)
                            setTaskReqtIdOpt(taskObj.taskId)
                          }}
                          onMouseLeave={() => {
                            setReqtMsgFlagProject(false)
                          }}
                          onClick={(
                            self.role[0].role === "ROLE_SUPERADMIN" ||
                            self.role[0].role === "ROLE_ADMIN" ||
                            editeKey === true ||
                            (empInfo.empId.toString() === self.empId.toString()) ||
                            (editeKey === false && self.empId?.toString() === taskObj.taskOwner.empId?.toString())
                          ) ? () => {
                            setTaskIdForOption(taskObj.taskId)
                            setProjectOption(true)
                          } : null}>
                          <div className="OutputWrapperProrityForRqt" style={{ backgroundColor: taskObj.request?.projectEntity === true && taskObj.projectEntity !== null ? 'rgb(201, 200, 200)' : null }}  >
                            <div className="OutputWrapperProject" >
                              <div style={{ width: '100%', overflow: 'hidden' }}><p>{taskObj.projectEntity ? taskObj.projectEntity.projectName : ' '}</p></div>
                            </div>
                          </div>

                          {/* {taskIdOption === taskObj.taskId && projectOption && dProjects.length > 0 &&
                            <div className="listOfProjectWrapper" ref={projectListRef}>
                              {taskObj.projectEntity !== null &&
                                <div className="clrPrj" onClick={() => {
                                  axios.put(`${apiUrl}task/update`, { "taskId": taskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskProject": null }, { headers: storedHeaders })
                                    .then(response => {
                                      setClicked(false)
                                      if (response.request.status === 200) {
                                        taskObj.request = response.data
                                        taskObj.projectEntity = null
                                        allTask[index] = taskObj
                                        setProjectOption(false)
                                        if (response.data.projectEntity === true) {
                                          toast.success("request for update project sent successfully", { toastId: 'success', autoClose: 2000 });
                                        } else {
                                          toast.success("task project updated successfully", { toastId: 'success', autoClose: 2000 });
                                        }
                                      }
                                      setProjectOption(false)
                                    })
                                    .catch((err) => {
                                      setClicked(false)
                                    })
                                }}>Clear</div>
                              }
                              <div className="listOfAsssigneeWrapperScroller listOfProjectScrooller">
                                {dProjects && dProjects.length > 0 && dProjects.map((projectObj) => (
                                  <div className="ProjectTitleDiv" onClick={() => {
                                    if (clicked) {
                                      return
                                    }
                                    setClicked(true)
                                    UPDATE(3, index, taskObj, projectObj)
                                  }}>{projectObj.projectName}</div>
                                ))}
                              </div>
                            </div>
                          } */}

                          {/* {taskIdOption === taskObj.taskId && projectOption && dProjects.length > 0 &&
                            <div className="triangleDivForList"></div>
                          }
                          */}
                          {/* {reqtMsgFlagProject && taskReqtIdOpt === taskObj.taskId && 
                            <div className="rqtMsgPrt">
                              {`Request already sent`}
                            </div>
                          } */}

                        </div>
                      </TableCell>


                      {/* <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div className="assignee_InfoContainer selectedAssigneeDiv selectMileStoneDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }} onClick={(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") ? () => {
                          axios.post(`${apiUrl}employee/get/task-owners`, { 'roleLevel': empInfo.role[0].roleLevel }, { headers: storedHeaders })
                            .then(response => {
                              if (response.request.status === 200) {
                                setAssigness(response.data)
                              }
                            })
                            .catch(error => {
                            })
  
                          setTaskIdForOption(taskObj.taskId)
                          setAssigneeOption(true)
                        } : null}>
                          <div className="taskOwnerImage"><img id="taskOwnerImage" src={taskObj.taskOwner.empImg ? taskObj.taskOwner.empImg : profile} alt="" /></div>
                          <div className="AssigneeName"><p>{taskObj.taskOwner?.empFullName}</p></div>
                        
                          {assigneeOption && taskIdOption === taskObj.taskId &&
                            <div className="listOfAsssigneeWrapper" style={{ zIndex: 1000 }} ref={assigneeRef}>
                              <div className="listOfAsssigneeWrapperScroller">
                                {assigness && assigness.length > 0 && assigness.map((emplObj) => (
                                  <div className="AssigneDiv-name-img" onClick={() => {
                                    UPDATE(6, index, taskObj, emplObj)
                                  }}>
                                    <div className="taskOwnerImage"><img id="taskOwnerImage" src={emplObj.empImg ? emplObj.empImg : profile} alt="" /></div>
                                    <div className="AssigneeName"><p>{emplObj?.empFullName}</p></div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          } 
                          
                        </div>
                      </TableCell> */}


                      {/* <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div className="assignee_InfoContainer selectedAssigneeDiv selectPhaseDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }} onClick={(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") ? () => {
                        //   axios.post(`${apiUrl}employee/get/task-owners`, { 'roleLevel': empInfo.role[0].roleLevel }, { headers: storedHeaders })
                        //     .then(response => {
                        //       if (response.request.status === 200) {
                        //         setAssigness(response.data)
                        //       }
                        //     })
                        //     .catch(error => {
                        //     })
  
                        //   setTaskIdForOption(taskObj.taskId)
                        //   setAssigneeOption(true)
                        } : null}>
                          {/* <div className="taskOwnerImage"><img id="taskOwnerImage" src={taskObj.taskOwner.empImg ? taskObj.taskOwner.empImg : profile} alt="" /></div>
                          <div className="AssigneeName"><p>{taskObj.taskOwner?.empFullName}</p></div> */}
                      {/*   
                          {assigneeOption && taskIdOption === taskObj.taskId &&
                            <div className="listOfAsssigneeWrapper" style={{ zIndex: 1000 }} ref={assigneeRef}>
                              <div className="listOfAsssigneeWrapperScroller">
                                {assigness && assigness.length > 0 && assigness.map((emplObj) => (
                                  <div className="AssigneDiv-name-img" onClick={() => {
                                    UPDATE(6, index, taskObj, emplObj)
                                  }}>
                                    <div className="taskOwnerImage"><img id="taskOwnerImage" src={emplObj.empImg ? emplObj.empImg : profile} alt="" /></div>
                                    <div className="AssigneeName"><p>{emplObj?.empFullName}</p></div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          } 
                          
                        </div>
                      </TableCell> */}

                      {/* <TableCell className={classes.columnResizer1}></TableCell>
                      <TableCell align="center" className="coloumnData">
                        <div className="assignee_InfoContainer selectedAssigneeDiv selectSprintDiv" style={{ minWidth: '200px', minHeight: '30px', textAlign: 'center' }} onClick={(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") ? () => {
                          axios.post(`${apiUrl}employee/get/task-owners`, { 'roleLevel': empInfo.role[0].roleLevel }, { headers: storedHeaders })
                            .then(response => {
                              if (response.request.status === 200) {
                                setAssigness(response.data)
                              }
                            })
                            .catch(error => {
                            })
  
                          setTaskIdForOption(taskObj.taskId)
                          setAssigneeOption(true)
                        } : null}>
                          <div className="taskOwnerImage"><img id="taskOwnerImage" src={taskObj.taskOwner.empImg ? taskObj.taskOwner.empImg : profile} alt="" /></div>
                          <div className="AssigneeName"><p>{taskObj.taskOwner?.empFullName}</p></div>
                          
                          {assigneeOption && taskIdOption === taskObj.taskId &&
                            <div className="listOfAsssigneeWrapper" style={{ zIndex: 1000 }} ref={assigneeRef}>
                              <div className="listOfAsssigneeWrapperScroller">
                                {assigness && assigness.length > 0 && assigness.map((emplObj) => (
                                  <div className="AssigneDiv-name-img" onClick={() => {
                                    UPDATE(6, index, taskObj, emplObj)
                                  }}>
                                    <div className="taskOwnerImage"><img id="taskOwnerImage" src={emplObj.empImg ? emplObj.empImg : profile} alt="" /></div>
                                    <div className="AssigneeName"><p>{emplObj?.empFullName}</p></div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          }
                          
                        </div>
                      </TableCell> */}


                    </TableRow>
                  ))}
                  <TableRow style={{background: 'red'}}>
                  
                  </TableRow>
                </TableBody>
              
              </Table>
            </TableContainer>
            {   isLastPage === false &&  
                  <div className="project-alltask0loader"> {
                     isLastPage ? <div className='taslLoadMore' /> : isLastPage === false ? <div className='load-more-projectAllTask ' onClick={ isLMclick === false ?  () => {
                     const stringHeaders = window.localStorage.getItem('myHeaders');
                     const storedHeaders = JSON.parse(stringHeaders);
                     setIsLMClick(true)
                     setPageNumber(pageNumber + 1);
                     axios.post(`${apiUrl}project/task/get/all?page=${pageNumber}&size=${100}`, { "projectId": project?.projectId }, { headers: storedHeaders })
                     .then(response => {
                       if (response) {
                        setIsLMClick(false)
                         dispatch(setReset(0))
                         setAllTask([...allTask, ...response.data.data])
                         setSelectAllCheckBox(false)
                         dispatch(setDispatchAllTask([...dispatchAllTask, ...response.data.data]))
                         dispatch(setDataObject(response.data))
                         var completedTaskCount = response.data.data?.filter(taskObj => taskObj.taskDone === 1).length;
                         setTotalAnalyatics(response.data.data.length)
                         setCompleteAnalytics(completedTaskCount);
                         setPriorityOption(false)
                         setStatusOption(false)
                         setTaskOfListPut([])
                         setTaskSeletedCount(0)
                         setSelectAllCheckBox(false)
                         setIsLastPage(response.data.isLastPage)
                         setRotating(false)
                         setTimeout(() => {
                           dispatch(setLoader(false))
                         }, 500);
                       }
                     })
   
                   .catch(err => {
                    setTaskOfListPut([])
                    setIsLMClick(false)
                    setTaskSeletedCount(0)
                    setSelectAllCheckBox(false)
                     dispatch(setLoader(false))
                   })
                      
                     } : null}>Load More <svg width="12" height="auto" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.33845 0.590253C4.43036 0.484195 4.42765 0.325932 4.33215 0.223087C4.22131 0.103723 4.03159 0.106345 3.92409 0.228726L2.25 2.13462L0.575908 0.228726C0.468411 0.106345 0.278686 0.103723 0.167848 0.223087C0.0723491 0.325932 0.0696354 0.484195 0.161553 0.590253L2.25 3L4.33845 0.590253Z" fill="#263238" />
                    </svg> </div> : null
                  }
                  </div>
                }
          </div>
        </div>

        {deleteTaskFlag &&
          <div className="deleteTaskPopup">
            <div className="deleteTaskSurityCard">
              <div className="deleteTaskSurityCard_heading"><p> Are you sure to Delete this Tasks ?</p></div>
              <div className="confirm_btn_deletetask">
                <button style={{ backgroundColor: 'rgba(255, 132, 2, 1)', color: 'rgba(255, 255, 255, 1)' }} onClick={() => {
                  const stringHeaders = window.localStorage.getItem('myHeaders');
                  const storedHeaders = JSON.parse(stringHeaders);
                  UPDATE_MULTIPLE(4, null)
                }}>{deleteloaderFlag ? <div className="deleteLoader"></div> : 'Delete'}</button>
                <button style={{ backgroundColor: 'rgba(232, 232, 232, 1)', color: 'rgba(38, 50, 56, 1)' }}
                  onClick={() => {
                    if (deleteTaskFlag === true) {
                      setDeleteTaskFlag(false)
                    }
                  }}
                >Cancel</button>
              </div>
            </div>
          </div>
        }

        {/* {taskOwnerDiff &&
          <div className="deleteTaskPopup">
            <div className="deleteTaskSurityCard mutilple-crudTaskupdate-card">
              <div className="deleteTaskSurityCard_heading"><p >{` from ${taskSelectedCount} tasks ${taskOnwerDiffReq.length} have the different task owner's`}</p></div>
              <div className="confirm_btn_deletetask">
                <button style={{ backgroundColor: 'rgba(255, 132, 2, 1)', color: 'rgba(255, 255, 255, 1)' }} onClick={() => { setOwnerDiff(false) }}>Ok</button>
              </div>
            </div>
          </div>
        } */}

{transforTaskPopUp &&
        <div className="transferTaskPopUp">
          <div className="tranfer_task_template">
            <div className="transfer_task_heading">
              {'Transfer Tasks'}
            </div>
            <div className="transfer_to_date">
              <p>Transfer to this date</p>
              {/* <input type="date" id="input-tranfer-date" value={dateForTransfer} onChange={(e) => {
                setDateForTransfer(e.target.value)

              }} /> */}

              <div className="tranferdDate-holder" onClick={() => { setTransferDteFlag(!transferDateFlag) }}>
                <div className='tranferDateSelected'>
                  <div className='rtnDatehlder'>{dateForTransfer}</div>
                  <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                    <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                    <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                  </svg>
                </div>

                {transferDateFlag &&
                  <div className='calender-holder-dashboard calender-holder-card' ref={transferDateRef}>
                    <div onClick={(e) => e.stopPropagation()}>
                      <Calendar value={dateForTransfer} inline onChange={(e) => {
                        const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                        setDateForTransfer(formattedDate)
                        setTransferDteFlag(false)
                      }} unstyled={false} />
                    </div>
                  </div>
                }
              </div>
            </div>
            
            <div className="transfer-to-assignee" onClick={ selectedTA !== null ? () => {
              setTAList(true)
            } : null}>
              <p>Transfer to</p>
              <div className="transfer_assignee_content">
                {selectedTA !== null &&
                  <div className="selettedssgineedivtransfer" >
                    <div className="taskOwnerImage">
                      <img id="taskOwnerImage" src={selectedTA.empImg ? selectedTA.empImg : profile} alt="" /></div>
                    <p>{selectedTA.empFullName}</p>
                  </div>
                }
                {  selectedTA === null && 
                  <input className="transeferSearchEmpl" value={serchKeyTrsn} type="text" placeholder="search employee..." onChange={(e) => {
                    handleSearchEmpTrns(e)
                    setSearchKeyTran(e.target.value)
                  }} />
              }
              </div>

              {TAList &&
                <div className="TAList_main_container " ref={TAListRef}>
                  {/* <div className="selectedTA">
                    {selectedTA !== null &&
                      <div className="selettedssgineedivtransfer" >
                        <div className="taskOwnerImage">
                          <img id="taskOwnerImage" src={selectedTA.empImg ? selectedTA.empImg : profile} alt="" /></div>
                        <p>{selectedTA.empFullName}</p>
                      </div>
                    }
                  </div> */}
                  <div className="TAScoller_ctn">
                    <div className="TAList_scoller">
                      {upDatedTranferList && upDatedTranferList.length > 0 && upDatedTranferList.map((emplObj, index) => (
                        <div className="AssigneDiv-name-img" onClick={() => {
                          setTAList(false)
                          setSelectedTA(emplObj)
                          setSearchKeyTran('')
                        }}>
                          <div className="taskOwnerImage"><img id="taskOwnerImage" src={emplObj.empImg ? emplObj.empImg : profile} alt="" /></div>
                          <div className="AssigneeName"><p>{emplObj?.empFullName}</p></div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="clearTrsEmp"><p style={{ cursor: 'pointer' }} onClick={() => setSelectedTA(null)}>Clear</p></div>
                </div>
              }
            </div>

            <div className="btn_for_transfer">
              <button className="btn-transfer" onClick={() => {
                setClicked(true)
                UPDATE_MULTIPLE(6, null)
                setTransferClicked(true)
              }}> {selectedTA !== null && transferClicked === true ? <div className="transferLoader"></div> : "Transfer"}</button>
              <button className="btn-tran-cancel" onClick={() => {
                setTransforTaskPopUp(false)
                setSelectedTA(null)
                setDateForTransfer(fullDateF)
                setTransferClicked(false)
                setClicked(false)
              }}>Cancel</button>
            </div>
          </div>
        </div>
      }

{ taskToTestpopup &&
        <div className="deleteTaskPopup">
          <div className="gitTaskSurityAdd" ref={gitTaskpopRef}>
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="svgCancelGitpop" onClick={() => settaskToTestpopup(false)}>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238"/>
              </svg>

            <div className="deleteTaskSurityCard_heading gitlinkpopheading">
              <label>Enter the git link</label>
              <input className="gitinputlink" placeholder="enter git link" autoFocus={true} value={gitLinkValue} type="text"  onChange={handleGitInputChange} onKeyDown={(e) => handleGitKeyDown(e)} />
            </div>
            <div className="confirm_btn_deletetask confirmForGitLink">
              <button style={{ backgroundColor: 'rgba(255, 132, 2, 1)', color: 'rgba(255, 255, 255, 1)' }} onClick={() => {
                   if(gitLinkValue && gitLinkValue !== gitTaskObj.taskGitLink){
                      if (isValidGitUrl(gitLinkValue))  {
                        const stringHeaders = window.localStorage.getItem('myHeaders');
                        const storedHeaders = JSON.parse(stringHeaders);
                        const index = allTask.findIndex((obj) => obj.taskId === gitTaskObj.taskId)
                        gitTaskObj.taskGitLink = gitLinkValue
                        allTask[index] = gitTaskObj
                        setAllTask(allTask)
                        dispatch(setDispatchAllTask(allTask))
                        setSaveGitFlag(true)
                        axios.put(`${apiUrl}task/update`, { "taskId": gitTaskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskGitLink": gitLinkValue, 'taskToTest' : false}, { headers: storedHeaders })
                          .then(response => {
                            if (response.request.status === 200) {
                              toast.success("task gitLink  Updated successfully", { toastId: 'success', autoClose: 2000 });
                              settaskToTestpopup(false)
                              setSaveGitFlag(false)
                            }
                            setAllTask(allTask)
                            setSaveGitFlag(false)
                          })
                          .catch(err => { 
                            setTesterFlag(false)
                            setSaveGitFlag(false)
                            toast.error("Error Occured", { toastId: 'success', autoClose: 2000 });
                          })
                      } else {
                        toast.error("Enter valid git link", { toastId: 'success', autoClose: 2000 });
                        setTesterFlag(false)
                        setTesterTaskId(null)
                        setSaveGitFlag(false)
                      }
                  }else{
                    if(gitLinkValue === null || gitLinkValue === ''){
                      toast.error('Enter git link', {autoClose: 2000})
                    }else{
                      toast.error('git link is already updated', {autoClose: 2000})
                    }
                  }
              }}>{saveGitFlag ? <div className="deleteLoader"></div> : 'Save'}</button>
            {  selfInfo?.department?.departmentId !== 3 && 

              <button style={{ backgroundColor: 'rgba(232, 232, 232, 1)', color: 'rgba(38, 50, 56, 1)', width: '110px' }}
                onClick={() => {
                    if (isValidGitUrl(gitLinkValue)) {
                      const stringHeaders = window.localStorage.getItem('myHeaders');
                      const storedHeaders = JSON.parse(stringHeaders);
                      const index = allTask.findIndex((obj) => obj.taskId === gitTaskObj.taskId)
                      gitTaskObj.taskGitLink = gitLinkValue
                      allTask[index] = gitTaskObj
                      setAllTask(allTask)
                      dispatch(setDispatchAllTask(allTask))
                      setSentTestFlag(true)
                      axios.put(`${apiUrl}task/update`, { "taskId": gitTaskObj.taskId, "empId": mtiID === true ? null : selfInfoEmp.empId, "taskGitLink": gitLinkValue, 'taskToTest' : true}, { headers: storedHeaders })
                        .then(response => {
                          if (response.request.status === 200) {
                            settaskToTestpopup(false)
                            setSentTestFlag(false)
                            toast.success("task for test request send successfully", { toastId: 'success', autoClose: 2000 });
                          }
                          setAllTask(allTask)
                          setSentTestFlag(false)
                        })
                        .catch(err => { 
                          setSentTestFlag(false)
                          toast.error("Error oCCured", { toastId: 'success', autoClose: 2000 });
                        })
                    } else {
                      toast.error("Enter valid git link", { toastId: 'success', autoClose: 2000 });
                      setTesterFlag(false)
                      setTesterTaskId(null)
                      setSentTestFlag(false)

                    }
                }}
              >{sentTestGitFlag ? <div className="deleteLoader"></div> : 'Send to tester'}</button>
              }
            </div>
          </div>
        </div>
      }

        {retqMulFlag &&
          <div className="deleteTaskPopup">
            <div className="deleteTaskSurityCard">
              <div className="deleteTaskSurityCard_heading"><p>Do you want to send the request?</p></div>
              <div className="confirm_btn_deletetask">
                <button style={{ backgroundColor: 'rgba(255, 132, 2, 1)', color: 'rgba(255, 255, 255, 1)' }} onClick={() => {
                  setRetqMulFlag(false)
                  return true
                }}>Confirm</button>
                <button style={{ backgroundColor: 'rgba(232, 232, 232, 1)', color: 'rgba(38, 50, 56, 1)' }}
                  onClick={() => {
                    if (deleteTaskFlag === true) {
                      setDeleteTaskFlag(false)
                      return false
                    }
                  }}
                >Cancel</button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

  )
}

export default ProjectTasks



